<app-nav></app-nav>
<section class="healthInsuranceProposal" *ngIf="!thankyouSection && !transactionFailureSection">
  <div class="container">
    <div class="col">
      <!-- <h4 class="form-title">Proposer's Details</h4> -->
      <div class="col-12 text-center">
        <span><b>Fill correct information as it will be used<br>for policy issuance and correspondence</b></span>
      </div>
      <ul class="nav nav-pills justify-content-left main-nav-pills" role="tablist">
        <li class="nav-item">
          <a class="nav-link" [ngClass]="{ 'active': !proposalTab}">Proposer's Details</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" [ngClass]="{ 'active': !insurerDetails}">Insured Details</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" [ngClass]="{ 'active': !nomineeDetails}">Nominee Details</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" [ngClass]="{ 'active': !healthDetails}">Health Declarations</a>
        </li>
      </ul>
      <div class="tab-content">
        <form name="form" #proposalFormTabOne="ngForm">
          <div [hidden]="proposalTab" class="container active"><br>
            <div class="row">
              <div class="col-2" style="padding-right:0px;">
                <p class="title mendatory">Title</p>
                <div class="sum-insured-input">
                  <div class="form-group">
                    <select class="form-control" name="title" (change)="getGenderValue($event)"
                      [(ngModel)]="proposal.title" id="title" #title="ngModel" required>
                      <option value="M">Mr</option>
                      <option value="F">Mrs</option>
                      <option value="F">Ms</option>
                    </select>
                    <div *ngIf="title.invalid && title.touched " class="error-message">
                      <div *ngIf="title.errors.required">
                        Title is required.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-5">
                <p class="title mendatory">First Name</p>
                <div class="sum-insured-input">
                  <div class="form-group">
                    <input class="form-control" type="text" name="fName" [(ngModel)]="proposal.firstName" id="fName"
                      #fName="ngModel" pattern="[a-zA-Z]+" maxlength="200" required>
                    <div *ngIf="fName.invalid && fName.touched " class="error-message">
                      <div *ngIf="fName.errors.required">
                        First Name is required.
                      </div>
                      <div *ngIf="fName.errors.pattern">
                        Please enter valid First name.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-5">
                <p class="title mendatory">Last Name</p>
                <div class="sum-insured-input">
                  <div class="form-group">
                    <input class="form-control" type="text" name="lName" [(ngModel)]="proposal.lastName" id="lName"
                      #lName="ngModel" pattern="[a-zA-Z\s]+" maxlength="200" required>
                    <div *ngIf="lName.invalid && lName.touched " class="error-message">
                      <div *ngIf="lName.errors.required">
                        Last Name is required.
                      </div>
                      <div *ngIf="lName.errors.pattern">
                        Please enter valid Last name.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <p class="title mendatory">Mobile No.</p>
                <div class="sum-insured-input">
                  <div class="form-group">
                    <input type="text" #mobile="ngModel" name="mobile" id="mobile" class="form-control"
                      placeholder="Mobile No." [(ngModel)]="proposal.mobile" #mobile1="ngModel" maxlength="10"
                      minlength="10" (keydown.space)="$event.preventDefault();" pattern="^((?!(0))[0-9]{1,10}\d*)$"
                      inputmode="numeric" required>
                    <div *ngIf="mobile.invalid && mobile.touched " class="error-message">
                      <div *ngIf="mobile.errors.required">
                        Mobile number is required.
                      </div>
                      <div *ngIf="mobile.errors.maxlength">
                        Mobile number should not be greater than 10 digits.
                      </div>
                      <div *ngIf="mobile.errors.minlength">
                        Mobile number must be at least 10 digits long.
                      </div>
                      <div *ngIf="(!mobile.errors.minlength || mobile.errors.pattern) && !mobile.errors.required">
                        Invalid mobile number.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <p class="title mendatory">E-mail Address</p>
                <div class="sum-insured-input">
                  <div class="form-group">
                    <input class="form-control" type="email" name="email" id="email" #email="ngModel"
                      [(ngModel)]="proposal.email" [email]="true" maxlength="100" required>
                    <div *ngIf="email.invalid && email.touched " class="error-message">
                      <div *ngIf="email.errors.required">
                        Email Address is required.
                      </div>
                      <div *ngIf="email.errors.email">
                        Please enter correct Email address.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <p class="title mendatory">DOB</p>
                <div class="sum-insured-input reg-date-input reg-date-input1">
                  <div class="input-group form-group reg-date-input2">
                    <div class="input-group addon">
                      <img
                        src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/common-icons/Date.svg">
                      <p-calendar [touchUI]="true" [readonlyInput]="true" [(ngModel)]="proposal.dob"
                        dateFormat="dd/mm/yy" [monthNavigator]="true" [yearNavigator]="true" yearRange="1960:{{currentDate.getFullYear()}}"
                        placeholder="Date" name="regDate" [maxDate]="currentDate" (onBlur)="checkValue()"
                        (onSelect)="getPremiumForRoyalSundram(); setDiagYearOfAddQuestions(proposal.dob)" keepInvalid
                        [required]="true"></p-calendar>
                      <span class="input-group-addon" id="basic-addon-dueDate"></span>
                    </div>
                  </div>
                  <div *ngIf="shouldBe18" class="error-message">
                    Date of birth should be greater than 18.
                  </div>
                  <div *ngIf="DOBrequired" class="error-message">
                    Date of Birth is required.
                  </div>
                </div>
              </div>
            </div>
            <div class="row" *ngIf="this.finalPremiumCheck">
              <div class="col-12">
                <p class="title">PAN Number</p>
                <div class="sum-insured-input">
                  <div class="form-group">
                    <input class="form-control" type="text" name="pan" #pan="ngModel" [(ngModel)]="proposal.panNumber"
                      pattern="[A-Z]{5}[0-9]{4}[A-Z]{1}">
                    <div *ngIf="pan.invalid && pan.touched " class="error-message">
                      <div *ngIf="pan.errors.pattern">
                        Please enter valid Pan number.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- <div class="col-6">
                <p class="title">Aadhaar Number</p>
                <div class="sum-insured-input">
                  <div class="form-group">
                    <input class="form-control" type="text" name="adhaar" #adhaar="ngModel"
                      [(ngModel)]="proposal.aadharCard" pattern="^\d{4}\d{4}\d{4}$">
                    <div *ngIf="adhaar.invalid && adhaar.touched " class="error-message">
                      <div *ngIf="adhaar.errors.pattern">
                        Please enter valid Aadhar number.
                      </div>
                    </div>
                  </div>
                </div>
              </div> -->
            </div>
            <div class="row">
              <div class="col-12">
                <p class="title mendatory">Marital Status</p>
                <div class="sum-insured-input">
                  <div class="form-group">
                    <select class="form-control long-text" id="marital" name="marital"
                      [(ngModel)]="proposal.maritalStatus" #marital="ngModel" required>
                      <option disabled selected value="">Marital Status</option>
                      <option valu="Single">SINGLE</option>
                      <option valu="Married">MARRIED</option>
                    </select>
                    <div *ngIf="marital.invalid && marital.touched " class="error-message">
                      <div *ngIf="marital.errors.required">
                        Please select Marital Status.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <p class="title mendatory">Education Qualification</p>
                <div class="sum-insured-input">
                  <div class="form-group">
                    <select class="form-control long-text" id="qual" name="qual"
                      [(ngModel)]="proposal.qualificationDetails" #qual="ngModel" required>
                      <option selected="selected" disabled value="">Educational Qualification</option>
                      <option value="Lesser than Matriculation">Lesser than Matriculation</option>
                      <option value="Matriculation">Matriculation</option>
                      <option value="Graduate">Graduate</option>
                      <option value="Post-Graduate">Post-Graduate</option>
                      <option value="Professional Course">Professional Course</option>
                    </select>
                    <div *ngIf="qual.invalid && qual.touched " class="error-message">
                      <div *ngIf="qual.errors.required">
                        Please select Education Qualification.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <p class="title mendatory">Occupation</p>
                <div class="sum-insured-input">
                  <div class="form-group">
                    <select class="form-control long-text" id="insuredOccupation" name="occupation"
                      [(ngModel)]="proposal.proposerOccupation" id="occupation" #occupation="ngModel" required>
                      <option selected="selected" disabled value="">OCCUPATION</option>
                      <option selected value="SALARIED">SALARIED</option>
                      <option value="SELF EMPLOYED">SELF EMPLOYED</option>
                      <option value="HOUSEWIFE">HOUSE WIFE</option>
                      <option value="STUDENT">STUDENT</option>
                      <option value="OTHERS">OTHERS</option>
                    </select>
                    <div *ngIf="occupation.invalid && occupation.touched " class="error-message">
                      <div *ngIf="occupation.errors.required">
                        Please select Occupation.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <p class="title mendatory">Annual Income</p>
                <div class="sum-insured-input">
                  <div class="form-group">
                    <select class="form-control long-text" id="income" name="income" [(ngModel)]="proposal.annualIncome"
                      #income="ngModel" required>
                      <option value="" selected disabled>Annual Income</option>
                      <option value="Less than Rs 50 Thousands">Less than Rs 50,000</option>
                      <option value="Rs 50 Thousands to 1 Lacs 50 Thousands">Rs 50,000 to 1,50,000
                      </option>
                      <option value="Rs 1 Lacs 50 Thousands to 3 Lacs">Rs 1,50,000 to 3,00,000</option>
                      <option value="Rs 3 Lacs to 5 Lacs">Rs 3,00,000 to 5,00,000</option>
                      <option value="More than Rs 5 Lacs">More than Rs 5,00,000</option>
                    </select>
                    <div *ngIf="income.invalid && income.touched " class="error-message">
                      <div *ngIf="income.errors.required">
                        Annual Income is required.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <p class="title mendatory">Residential Address (To receive correspondence)</p>
                <div class="sum-insured-input">
                  <div class="form-group">
                    <input class="form-control" type="text" name="address1" [(ngModel)]="proposal.address1"
                      id="address1" #address1="ngModel" maxlength="500" required>
                    <div *ngIf="address1.invalid && address1.touched " class="error-message">
                      <div *ngIf="address1.errors.required">
                        Address is required.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- <div class="row">
              <div class="col-12">
                <p class="title mendatory">Landmark</p>
                <div class="sum-insured-input">
                  <div class="form-group">
                    <input class="form-control" type="text" name="address2" [(ngModel)]="proposal.address2"
                      id="address2" #address2="ngModel" maxlength="500" required>
                    <div *ngIf="address2.invalid && address2.touched " class="error-message">
                      <div *ngIf="address2.errors.required">
                        Landmark is required.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div> -->
            <div class="row">
              <div class="col-12">
                <p class="title mendatory">Pin Code</p>
                <div class="sum-insured-input">
                  <div class="form-group">
                    <input class="form-control" type="number" name="pinCode" [(ngModel)]="proposal.pincode"
                      (keydown.space)="$event.preventDefault();" (keypress)="keyPress($event)"
                      (focusout)="getCityStateList(f.pincode)" maxlength="6" minlength="6" id="pinCode"
                      #pinCode="ngModel"
                      oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                      required>
                    <div *ngIf="invalidPincode" class="error-message">
                      Invalid pincode.
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <p class="title mendatory">State</p>
                <div class="sum-insured-input">
                  <div class="form-group">
                    <select class="form-control" name="state" [(ngModel)]="proposal.state"
                      (change)="getStateCityForRoyal(2, proposal.state)" required>
                      <option value="" selected disabled>Select State</option>
                      <option *ngFor="let state of royalStateList" value="{{state}}">{{state}}</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <p class="title mendatory">City</p>
                <div class="sum-insured-input">
                  <div class="form-group">
                    <select name="city" class="form-control quote-dropdown" id="city" name="city"
                      [(ngModel)]="proposal.city" #city="ngModel" required>
                      <option *ngFor="let city of royalCityList" value="{{city}}">{{city | uppercase}}</option>
                    </select>
                    <div *ngIf="city.invalid && city.touched " class="error-message">
                      <div *ngIf="city.errors.required">
                        City is required.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <p class="title mendatory">TPA</p>
                <div class="sum-insured-input">
                  <div class="form-group">
                    <select class="form-control" name="tpa" [(ngModel)]="proposal.tpa" required>
                      <option selected value="Medi Assist Insurance (TPA) Pvt Ltd">Medi Assist Insurance (TPA) Pvt Ltd
                      </option>
                      <option value="Paramount Health Services (TPA) Pvt Ltd">Paramount Health Services (TPA) Pvt Ltd
                      </option>
                      <option value="Raksha Health Insurance TPA PVT. LTD">Raksha Health Insurance TPA PVT. LTD</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <!-- <div class="row">
              <div class="col-md-12">
                <div class="form-group mt-3">
                  <input type="checkbox" name="hospitalCash" (change)="getPremiumForRoyalSundram()"
                    [(ngModel)]="proposal.hospitalCashBenifit" /> Hospital Cash
                  Benifit
                </div>
              </div>
            </div> -->
            <div class="row mt-4">
              <!-- <div class="col-6">
                <button class="btn btn-bordered-blue pull-left">Save</button>
              </div> -->
              <!-- <div class="col-6 text-right">
                <button class="btn btn-bordered-blue" (click)="openModal(template)">Proceed</button>
              </div> -->
              <div class="col-12 text-center">
                <button class="btn btn-bordered-blue" [disabled]="!proposalFormTabOne.valid" (click)="nextStep('1')"
                  id="proceedPayment">Proceed</button>
              </div>
            </div>
          </div>
        </form>
        <div [hidden]="insurerDetails" class="container insuredDetails">
          <div (click)="backtoprevTab('2')" class="left-arw"></div>
          <div class="row sub-nav-tab">
            <ul class="nav nav-pills justify-content-left" role="tablist">
              <li class="nav-item">
                <a class="nav-link active" data-toggle="pill" href="#self" data-toggle="tab">Self</a>
              </li>
              <li class="nav-item" *ngIf="quoteDetails.isspouse">
                <a class="nav-link" data-toggle="pill" href="#spouse" data-toggle="tab">Spouse</a>
              </li>
              <li class="nav-item" *ngIf="quoteDetails.childSize">
                <a class="nav-link" data-toggle="pill" href="#kid1" data-toggle="tab">1 Kid</a>
              </li>
              <li class="nav-item" *ngIf="quoteDetails.childSize === '2' || quoteDetails.childSize === '3'">
                <a class="nav-link" data-toggle="pill" href="#kid2" data-toggle="tab">2 Kid</a>
              </li>
              <li class="nav-item" *ngIf="quoteDetails.childSize === '3'">
                <a class="nav-link" data-toggle="pill" href="#kid3" data-toggle="tab">3 Kid</a>
              </li>
            </ul>
            <div class="tab-content">
              <div id="self" class="container tab-pane active"><br>
                <form name="form">
                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <select class="form-control" name="insurerMemberRelation1"
                          [(ngModel)]="proposal.insurerMemberRelation1">
                          <option value="Self">SELF</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-2" style="padding-right:0px;">
                      <p class="title mendatory">Title</p>
                      <div class="sum-insured-input">
                        <div class="form-group">
                          <select class="form-control" name="selfTitle" [(ngModel)]="proposal.insuredPersonGender1"
                            id="selfTitle" #selfTitle="ngModel" required>
                            <option value="M">Mr</option>
                            <option value="Mrs">Mrs</option>
                            <option value="MS">Ms</option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div class="col-5">
                      <p class="title mendatory">First Name</p>
                      <div class="sum-insured-input">
                        <div class="form-group">
                          <input class="form-control" type="text" name="selfFirstName"
                            [(ngModel)]="proposal.insuredPersonFirstName1" id="selfFirstName" #selfFirstName="ngModel"
                            pattern="[a-zA-Z]+" maxlength="200" required disabled>
                        </div>
                      </div>
                    </div>
                    <div class="col-5">
                      <p class="title mendatory">Last Name</p>
                      <div class="sum-insured-input">
                        <div class="form-group">
                          <input class="form-control" type="text" name="selfLastName"
                            [(ngModel)]="proposal.insuredPersonLastName1" id="selfLastName" #selfLastName="ngModel"
                            pattern="[a-zA-Z\s]+" maxlength="200" required disabled>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12">
                      <p class="title mendatory">Date of Birth</p>
                      <div class="sum-insured-input reg-date-input">
                        <div class="input-group form-group">
                          <div class="input-group addon">
                            <img
                              src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/common-icons/Date.svg">
                            <p-calendar [touchUI]="true" [readonlyInput]="true" [(ngModel)]="proposal.insurerDob1"
                              dateFormat="dd/mm/yy" [monthNavigator]="true" [yearNavigator]="true" yearRange="1960:{{currentDate.getFullYear()}}"
                              placeholder="Date" name="regDate" [maxDate]="value" (onBlur)="checkValue()"
                              (onSelect)="calculateAge()" keepInvalid required disabled></p-calendar>
                            <span class="input-group-addon" id="basic-addon-dueDate"></span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-6">
                      <p class="title">Height (in cm)</p>
                      <div class="sum-insured-input">
                        <div class="form-group">
                          <input class="form-control" (keyup)="calculateBmi('1')" type="text" name="selfHeight"
                            #selfHeight="ngModel" [(ngModel)]="proposal.height1" required>
                          <div *ngIf="selfHeight.invalid && selfHeight.touched " class="error-message">
                            <div *ngIf="selfHeight.errors.pattern">
                              Please enter Height.
                            </div>
                            <div *ngIf="selfHeight.errors.pattern">
                              Please enter valid Aadhar number.
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-6">
                      <p class="title">Weight (Kg)</p>
                      <div class="sum-insured-input">
                        <div class="form-group">
                          <input class="form-control" (keyup)="calculateBmi('1')" type="text" name="weight1"
                            #weight1="ngModel" [(ngModel)]="proposal.weight1" required pattern="^\d{4}\d{4}\d{4}$">
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12">
                      <p class="title mendatory">Occupation</p>
                      <div class="sum-insured-input">
                        <div class="form-group">
                          <select class="form-control long-text" id="selfOccupation" name="selfOccupation"
                            [(ngModel)]="proposal.occupation1" required #selfOccupation="ngModel">
                            <option selected="" disabled="" value="">OCCUPATION</option>
                            <option selected value="SALARIED">SALARIED</option>
                            <option value="SELF EMPLOYED">SELF EMPLOYED</option>
                            <option value="HOUSEWIFE">HOUSE WIFE</option>
                            <option value="STUDENT">STUDENT</option>
                            <option value="OTHERS">OTHERS</option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row" *ngIf="proposal.occupation1 === 'SALARIED' || proposal.occupation1 === 'OTHERS'">
                    <div class="col-12">
                      <p class="title mendatory">Designation</p>
                      <input class="form-control" required type="text" name="designation1"
                        [(ngModel)]="proposal.designation1" />
                    </div>
                  </div>
                  <div class="row" *ngIf="proposal.occupation1 === 'SELF EMPLOYED'">
                    <div class="col-12">
                      <p class="title mendatory">Business</p>
                      <input class="form-control" required type="text" name="business1"
                        [(ngModel)]="proposal.business1" />
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-6">
                      <div class="row">
                        <div class="col">
                          <span class="title" style="display:block">Smoke</span>
                          <input type="radio" name="smoke" [(ngModel)]="proposal.smokingInsurer1" value="No"><span
                            class="mr80 ml-2 mr-2">No</span>
                          <input type="radio" name="smoke" [(ngModel)]="proposal.smokingInsurer1" value="Yes"><span
                            class="ml-2">Yes</span>
                        </div>
                      </div>
                      <div class="row" *ngIf="proposal.smokingInsurer1 === 'Yes'">
                        <div class="col mt-3">
                          <div class="form-group">
                            <input type="text" class="form-control" placeholder="Since Years" name="smokeYear"
                              [(ngModel)]="proposal.insurerSmokingNumberOfYear1" id="smokeYear" #smokeYear="ngModel"
                              pattern="^((?!(0))[0-9]{1,10}\d*)$" inputmode="numeric" required>
                          </div>
                          <div class="form-group">
                            <input type="text" name="smokeDays" id="smokeDays" class="form-control"
                              placeholder="No. (In a day)" [(ngModel)]="proposal.insurerSmokingQuantity1"
                              #smokeDays="ngModel" (keydown.space)="$event.preventDefault();"
                              pattern="^((?!(0))[0-9]{1,10}\d*)$" inputmode="numeric">
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-6">
                      <div class="row">
                        <div class="col">
                          <span class="title" style="display:block">Narcotics</span>
                          <input type="radio" name="narcotics" value="No"
                            [(ngModel)]="proposal.insurerConsumeNarcotics1"><span class="mr80 ml-2 mr-2">No</span>
                          <input type="radio" name="narcotics" value="Yes"
                            [(ngModel)]="proposal.insurerConsumeNarcotics1"><span class="ml-2">Yes</span>
                        </div>
                      </div>
                      <div class="row" *ngIf="proposal.insurerConsumeNarcotics1 === 'Yes'">
                        <div class="col mt-3">
                          <div class="form-group">
                            <input type="text" class="form-control" placeholder="Since Years" name="narcoticsYear"
                              [(ngModel)]="proposal.insurerConsumeNarcoticsNumberOfYear1" id="narcoticsYear"
                              #narcoticsYear="ngModel" pattern="^((?!(0))[0-9]{1,10}\d*)$" inputmode="numeric">
                          </div>
                          <div class="form-group">
                            <input type="text" name="narcoticsQuantity" id="narcoticsQuantity" class="form-control"
                              placeholder="Quantity" [(ngModel)]="proposal.insurerConsumeNarcoticsQuantity1"
                              #narcoticsQuantity="ngModel" (keydown.space)="$event.preventDefault();"
                              pattern="^((?!(0))[0-9]{1,10}\d*)$" inputmode="numeric">
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-6">
                      <div class="row">
                        <div class="col">
                          <span class="title" style="display:block">Alcohol</span>
                          <input type="radio" name="alcohol" value="No"
                            [(ngModel)]="proposal.insurerConsumeAlcohol1"><span class="mr80 ml-2 mr-2">No</span>
                          <input type="radio" name="alcohol" value="Yes"
                            [(ngModel)]="proposal.insurerConsumeAlcohol1"><span class="ml-2">Yes</span>
                        </div>
                      </div>
                      <div class="row" *ngIf="proposal.insurerConsumeAlcohol1 === 'Yes'">
                        <div class="col mt-3">
                          <div class="form-group">
                            <input type="text" class="form-control" placeholder="Since Years" name="alcoholYear"
                              [(ngModel)]="proposal.insurerConsumeAlcoholNumberOfYear1" id="alcoholYear"
                              #alcoholYear="ngModel" pattern="^((?!(0))[0-9]{1,10}\d*)$" inputmode="numeric">
                          </div>
                          <div class="form-group">
                            <input type="text" name="alcoholQuantity" id="alcoholQuantity" class="form-control"
                              placeholder="Quantity" [(ngModel)]="proposal.insurerConsumeAlcoholQuantity1"
                              #alcoholQuantity="ngModel" (keydown.space)="$event.preventDefault();"
                              pattern="^((?!(0))[0-9]{1,10}\d*)$" inputmode="numeric">
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-6">
                      <div class="row">
                        <div class="col">
                          <span class="title" style="display:block">Tobacco/Guthka, etc</span>
                          <input type="radio" name="tobacco" value="No"
                            [(ngModel)]="proposal.insurerConsumeTobacco1"><span class="mr80 ml-2 mr-2">No</span>
                          <input type="radio" name="tobacco" value="Yes" [(ngModel)]="proposal.insurerConsumeTobacco1"
                            [checked]="proposal.tobacco"><span class="ml-2">Yes</span>
                        </div>
                      </div>
                      <div class="row" *ngIf="proposal.insurerConsumeTobacco1 === 'Yes'">
                        <div class="col mt-3">
                          <div class="form-group">
                            <input type="text" class="form-control" placeholder="Since Years" name="tobaccoYear"
                              [(ngModel)]="proposal.insurerTobaccoNumberOfYear1" id="tobaccoYear" #tobaccoYear="ngModel"
                              pattern="^((?!(0))[0-9]{1,10}\d*)$" inputmode="numeric">
                          </div>
                          <div class="form-group">
                            <input type="text" name="tobaccoDays" id="tobaccoDays" class="form-control"
                              placeholder="No. of packs(In a day)" [(ngModel)]="proposal.insurerTobaccoQuantity1"
                              #tobaccoDays="ngModel" (keydown.space)="$event.preventDefault();"
                              pattern="^((?!(0))[0-9]{1,10}\d*)$" inputmode="numeric">
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row mt-4">
                    <div class="col-12 text-center">
                      <button class="btn btn-bordered-blue" (click)="nextStep('2')">Next</button>
                    </div>
                  </div>
                </form>
              </div>
              <!--if spuse this form show will optimize this code-->
              <ng-container *ngIf="quoteDetails.isspouse">
                <div id="spouse" class="container tab-pane fade"><br>
                  <form name="form" #proposalFormTabTwo2="ngForm">
                    <div class="row">
                      <div class="col-md-12">
                        <div class="form-group">
                          <select class="form-control" name="insurerMemberRelation2"
                            [(ngModel)]="proposal.insurerMemberRelation2">
                            <option value="Spouse">SPOUSE</option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-2 pr-0">
                        <p class="title mendatory">Title</p>
                        <div class="sum-insured-input">
                          <div class="form-group">
                            <select class="form-control" name="spouseTitle" [(ngModel)]="proposal.insuredPersonGender2"
                              id="spouseTitle" #spouseTitle="ngModel">
                              <option value="M">Mr</option>
                              <option value="F">Mrs</option>
                              <option value="F">Ms</option>
                            </select>
                          </div>
                        </div>
                      </div>
                      <div class="col-5">
                        <p class="title mendatory">First Name</p>
                        <div class="sum-insured-input">
                          <div class="form-group">
                            <input class="form-control" type="text" name="spouseFirstName"
                              [(ngModel)]="proposal.insuredPersonFirstName2" id="spouseFirstName"
                              #spouseFirstName="ngModel" pattern="[a-zA-Z]+" maxlength="200">
                          </div>
                        </div>
                      </div>
                      <div class="col-5">
                        <p class="title mendatory">Last Name</p>
                        <div class="sum-insured-input">
                          <div class="form-group">
                            <input class="form-control" type="text" name="selfLastName"
                              [(ngModel)]="proposal.insuredPersonLastName2" id="selfLastName" #selfLastName="ngModel"
                              pattern="[a-zA-Z\s]+" maxlength="200">
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12">
                        <p class="title mendatory">Date of Birth</p>
                        <div class="sum-insured-input reg-date-input">
                          <div class="input-group form-group">
                            <div class="input-group addon">
                              <img
                                src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/common-icons/Date.svg">
                              <p-calendar [touchUI]="true" [readonlyInput]="true" [(ngModel)]="proposal.insurerDob2"
                                dateFormat="dd/mm/yy" [monthNavigator]="true" [yearNavigator]="true"
                                yearRange="1960:{{currentDate.getFullYear()}}" placeholder="Date" name="regDate" [maxDate]="currentDate"
                                (onBlur)="checkValue()" (onSelect)="calculateAge()" keepInvalid></p-calendar>
                              <span class="input-group-addon" id="basic-addon-dueDate"></span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-6">
                        <p class="title">Height (in meters)</p>
                        <div class="sum-insured-input">
                          <div class="form-group">
                            <input class="form-control" type="text" (keyup)="calculateBmi('2')" name="spouseHeight"
                              #spouseHeight="ngModel" [(ngModel)]="proposal.height2">
                          </div>
                        </div>
                      </div>
                      <div class="col-6">
                        <p class="title">Weight (Kg)</p>
                        <div class="sum-insured-input">
                          <div class="form-group">
                            <input class="form-control" type="text" (keyup)="calculateBmi('2')" name="spouseWeight"
                              #spouseWeight="ngModel" [(ngModel)]="proposal.weight2" pattern="^\d{4}\d{4}\d{4}$">
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12">
                        <p class="title mendatory">Occupation</p>
                        <div class="sum-insured-input">
                          <div class="form-group">
                            <select class="form-control long-text" id="spouseOccupation" name="spouseOccupation"
                              [(ngModel)]="proposal.occupation2" required #spouseOccupation="ngModel">
                              <option selected="" disabled="" value="">OCCUPATION</option>
                              <option value="SALARIED">SALARIED</option>
                              <option value="SELF EMPLOYED">SELF EMPLOYED</option>
                              <option value="HOUSEWIFE">HOUSE WIFE</option>
                              <option value="STUDENT">STUDENT</option>
                              <option value="OTHERS">OTHERS</option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row" *ngIf="proposal.occupation2 === 'SALARIED' || proposal.occupation2 === 'OTHERS'">
                      <div class="col-12">
                        <p class="title mendatory">Designation</p>
                        <input class="form-control" required type="text" name="designation2"
                          [(ngModel)]="proposal.designation2" />
                      </div>
                    </div>
                    <div class="row" *ngIf="proposal.occupation2 === 'SELF EMPLOYED'">
                      <div class="col-12">
                        <p class="title mendatory">Business</p>
                        <input class="form-control" required type="text" name="business2"
                          [(ngModel)]="proposal.business2" />
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-6">
                        <div class="row">
                          <div class="col">
                            <span class="title" style="display:block">Smoke</span>
                            <input type="radio" name="spouseSmoke" value="No"
                              [(ngModel)]="proposal.smokingInsurer2"><span class="mr80 ml-2 mr-2">No</span>
                            <input type="radio" name="spouseSmoke" [(ngModel)]="proposal.smokingInsurer2" value="Yes"
                              [checked]="proposal.spouseSmoke"><span class="ml-2">Yes</span>
                          </div>
                        </div>
                        <div class="row" *ngIf="proposal.smokingInsurer2 === 'Yes'">
                          <div class="col mt-3">
                            <div class="form-group">
                              <input type="text" class="form-control" placeholder="Since Years" name="spouseSmokeYear"
                                [(ngModel)]="proposal.insurerSmokingNumberOfYear2" id="spouseSmokeYear"
                                #spouseSmokeYear="ngModel" pattern="^((?!(0))[0-9]{1,10}\d*)$" inputmode="numeric"
                                required>
                            </div>
                            <div class="form-group">
                              <input type="text" name="spouseSmokeDays" id="spouseSmokeDays" class="form-control"
                                placeholder="No. (In a day)" [(ngModel)]="proposal.insurerSmokingQuantity2"
                                #spouseSmokeDays="ngModel" (keydown.space)="$event.preventDefault();"
                                pattern="^((?!(0))[0-9]{1,10}\d*)$" inputmode="numeric">
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-6">
                        <div class="row">
                          <div class="col">
                            <span class="title" style="display:block">Narcotics</span>
                            <input type="radio" name="spouseNarcotics" [(ngModel)]="proposal.insurerConsumeNarcotics2"
                              value="No"><span class="mr80 ml-2 mr-2">No</span>
                            <input type="radio" name="spouseNarcotics" [(ngModel)]="proposal.insurerConsumeNarcotics2"
                              value="Yes" [checked]="proposal.spouseNarcotics"><span class="ml-2">Yes</span>
                          </div>
                        </div>
                        <div class="row" *ngIf="proposal.insurerConsumeNarcotics2 === 'Yes'">
                          <div class="col mt-3">
                            <div class="form-group">
                              <input type="text" class="form-control" placeholder="Since Years"
                                name="spouseNarcoticsYear" [(ngModel)]="proposal.insurerConsumeNarcoticsNumberOfYear2"
                                id="spouseNarcoticsYear" #spouseNarcoticsYear="ngModel"
                                pattern="^((?!(0))[0-9]{1,10}\d*)$" inputmode="numeric">
                            </div>
                            <div class="form-group">
                              <input type="text" name="spouseNarcoticsQuantity" id="spouseNarcoticsQuantity"
                                class="form-control" placeholder="Quantity"
                                [(ngModel)]="proposal.insurerConsumeNarcoticsQuantity2"
                                #spouseNarcoticsQuantity="ngModel" (keydown.space)="$event.preventDefault();"
                                pattern="^((?!(0))[0-9]{1,10}\d*)$" inputmode="numeric">
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-6">
                        <div class="row">
                          <div class="col">
                            <span class="title" style="display:block">Alcohol</span>
                            <input type="radio" name="spouseAlcohol" value="No"
                              [(ngModel)]="proposal.insurerConsumeAlcohol2"><span class="mr80 ml-2 mr-2">No</span>
                            <input type="radio" name="spouseAlcohol" [(ngModel)]="proposal.insurerConsumeAlcohol2"
                              value="Yes" [checked]="proposal.spouseAlcohol"><span class="ml-2">Yes</span>
                          </div>
                        </div>
                        <div class="row" *ngIf="proposal.insurerConsumeAlcohol2 === 'Yes'">
                          <div class="col mt-3">
                            <div class="form-group">
                              <input type="text" class="form-control" placeholder="Since Years" name="spouseAlcoholYear"
                                [(ngModel)]="proposal.insurerConsumeAlcoholNumberOfYear2" id="spouseAlcoholYear"
                                #spouseAlcoholYear="ngModel" pattern="^((?!(0))[0-9]{1,10}\d*)$" inputmode="numeric">
                            </div>
                            <div class="form-group">
                              <input type="text" name="spouseAlcoholQuantity" id="spouseAlcoholQuantity"
                                class="form-control" placeholder="Quantity"
                                [(ngModel)]="proposal.insurerConsumeAlcoholQuantity2" #spouseAlcoholQuantity="ngModel"
                                (keydown.space)="$event.preventDefault();" pattern="^((?!(0))[0-9]{1,10}\d*)$"
                                inputmode="numeric">
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-6">
                        <div class="row">
                          <div class="col">
                            <span class="title" style="display:block">Tobacco/Guthka, etc</span>
                            <input type="radio" value="No" name="spouseTobacco"
                              [(ngModel)]="proposal.insurerConsumeTobacco2"><span class="mr80 ml-2 mr-2">No</span>
                            <input type="radio" name="spouseTobacco" [(ngModel)]="proposal.insurerConsumeTobacco2"
                              value="Yes" [checked]="proposal.spouseTobacco"><span class="ml-2">Yes</span>
                          </div>
                        </div>
                        <div class="row" *ngIf="proposal.insurerConsumeTobacco2 === 'Yes'">
                          <div class="col mt-3">
                            <div class="form-group">
                              <input type="text" class="form-control" placeholder="Since Years" name="spouseTobaccoYear"
                                [(ngModel)]="proposal.insurerTobaccoNumberOfYear2" id="spouseTobaccoYear"
                                #spouseTobaccoYear="ngModel" pattern="^((?!(0))[0-9]{1,10}\d*)$" inputmode="numeric">
                            </div>
                            <div class="form-group">
                              <input type="text" name="spouseTobaccoDays" id="spouseTobaccoDays" class="form-control"
                                placeholder="No. of packs(In a day)" [(ngModel)]="proposal.insurerTobaccoQuantity2"
                                #spouseTobaccoDays="ngModel" (keydown.space)="$event.preventDefault();"
                                pattern="^((?!(0))[0-9]{1,10}\d*)$" inputmode="numeric">
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row mt-4">
                      <div class="col-12 text-center">
                        <button class="btn btn-bordered-blue" (click)="nextStep('2')">Next</button>
                      </div>
                    </div>
                  </form>
                </div>
                <div id="kid1" class="container tab-pane fade"><br>
                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <select class="form-control" name="insurerMemberRelation3"
                          [(ngModel)]="proposal.insurerMemberRelation3">
                          <option value="SON">SON</option>
                          <option value="DAUGHTER">DAUGHTER</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-2 pr-0">
                      <p class="title mendatory">Title</p>
                      <div class="sum-insured-input">
                        <div class="form-group">
                          <select class="form-control" name="kid1Title" [(ngModel)]="proposal.insuredPersonGender3"
                            id="kid1Title" #kid1Title="ngModel">
                            <option value="M">Mr</option>
                            <option value="F">Mrs</option>
                            <option value="F">Ms</option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div class="col-5">
                      <p class="title mendatory">First Name</p>
                      <div class="sum-insured-input">
                        <div class="form-group">
                          <input class="form-control" type="text" name="kid1FirstName"
                            [(ngModel)]="proposal.insuredPersonFirstName3" id="kid1FirstName" #kid1FirstName="ngModel"
                            pattern="[a-zA-Z]+" maxlength="200">
                        </div>
                      </div>
                    </div>
                    <div class="col-5">
                      <p class="title mendatory">Last Name</p>
                      <div class="sum-insured-input">
                        <div class="form-group">
                          <input class="form-control" type="text" name="kid1LastName"
                            [(ngModel)]="proposal.insuredPersonLastName3" id="kid1LastName" #kid1LastName="ngModel"
                            pattern="[a-zA-Z\s]+" maxlength="200">
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12">
                      <p class="title mendatory">Date of Birth</p>
                      <div class="sum-insured-input reg-date-input reg-date-input1">
                        <div class="input-group form-group">
                          <div class="input-group addon">
                            <img
                              src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/common-icons/Date.svg">
                            <p-calendar [touchUI]="true" [readonlyInput]="true" [(ngModel)]="proposal.insurerDob3"
                              dateFormat="dd/mm/yy" [monthNavigator]="true" [yearNavigator]="true" yearRange="1960:{{currentDate.getFullYear()}}"
                              placeholder="Date" name="regDate" [maxDate]="currentDate" (onBlur)="checkValue()"
                              (onSelect)="calculateAge()" keepInvalid></p-calendar>
                            <span class="input-group-addon" id="basic-addon-dueDate"></span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-6">
                      <p class="title">Height (in meters)</p>
                      <div class="sum-insured-input">
                        <div class="form-group">
                          <input class="form-control" type="text" (keyup)="calculateBmi('3')" name="kid1Height"
                            #kid1Height="ngModel" [(ngModel)]="proposal.height3">
                        </div>
                      </div>
                    </div>
                    <div class="col-6">
                      <p class="title">Weight (Kg)</p>
                      <div class="sum-insured-input">
                        <div class="form-group">
                          <input class="form-control" type="text" (keyup)="calculateBmi('3')" name="kid1Weight"
                            #kid1Weight="ngModel" [(ngModel)]="proposal.weight3" pattern="^\d{4}\d{4}\d{4}$">
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12">
                      <p class="title mendatory">Occupation</p>
                      <div class="sum-insured-input">
                        <div class="form-group">
                          <select class="form-control long-text" id="kid1Occupation" name="kid1Occupation"
                            [(ngModel)]="proposal.occupation3" required #kid1Occupation="ngModel">
                            <option selected="" disabled="" value="">OCCUPATION</option>
                            <option value="SALARIED">SALARIED</option>
                            <option value="SELF EMPLOYED">SELF EMPLOYED</option>
                            <option value="HOUSEWIFE">HOUSE WIFE</option>
                            <option value="STUDENT">STUDENT</option>
                            <option value="OTHERS">OTHERS</option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row" *ngIf="proposal.occupation3 === 'SALARIED' || proposal.occupation3 === 'OTHERS'">
                    <div class="col-12">
                      <p class="title mendatory">Designation</p>
                      <input class="form-control" required type="text" name="designation3"
                        [(ngModel)]="proposal.designation3" />
                    </div>
                  </div>
                  <div class="row" *ngIf="proposal.occupation3 === 'SELF EMPLOYED'">
                    <div class="col-12">
                      <p class="title mendatory">Business</p>
                      <input class="form-control" required type="text" name="business3"
                        [(ngModel)]="proposal.business3" />
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-6">
                      <div class="row">
                        <div class="col">
                          <span class="title" style="display:block">Smoke</span>
                          <input type="radio" name="kid1Smoke" value="No" [(ngModel)]="proposal.smokingInsurer3"><span
                            class="mr80 ml-2 mr-2">No</span>
                          <input type="radio" name="kid1Smoke" [(ngModel)]="proposal.smokingInsurer3" value="Yes"
                            [checked]="proposal.kid1Smoke"><span class="ml-2">Yes</span>
                        </div>
                      </div>
                      <div class="row" *ngIf="proposal.smokingInsurer3 === 'Yes'">
                        <div class="col mt-3">
                          <div class="form-group">
                            <input type="text" class="form-control" placeholder="Since Years" name="kid1SmokeYear"
                              [(ngModel)]="proposal.insurerSmokingNumberOfYear3" id="kid1SmokeYear"
                              #kid1SmokeYear="ngModel" pattern="^((?!(0))[0-9]{1,10}\d*)$" inputmode="numeric">
                          </div>
                          <div class="form-group">
                            <input type="text" name="kid1SmokeDays" id="kid1SmokeDays" class="form-control"
                              placeholder="No. (In a day)" [(ngModel)]="proposal.insurerSmokingQuantity3"
                              #kid1SmokeDays="ngModel" (keydown.space)="$event.preventDefault();"
                              pattern="^((?!(0))[0-9]{1,10}\d*)$" inputmode="numeric">
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-6">
                      <div class="row">
                        <div class="col">
                          <span class="title" style="display:block">Narcotics</span>
                          <input type="radio" value="No" name="kid1Narcotics"
                            [(ngModel)]="proposal.insurerConsumeNarcotics3"><span class="mr80 ml-2 mr-2">No</span>
                          <input type="radio" name="kid1Narcotics" [(ngModel)]="proposal.insurerConsumeNarcotics3"
                            value="Yes" [checked]="proposal.kid1Narcotics"><span class="ml-2">Yes</span>
                        </div>
                      </div>
                      <div class="row" *ngIf="proposal.insurerConsumeNarcotics3 === 'Yes'">
                        <div class="col mt-3">
                          <div class="form-group">
                            <input type="text" class="form-control" placeholder="Since Years" name="kid1NarcoticsYear"
                              [(ngModel)]="proposal.insurerConsumeNarcoticsNumberOfYear3" id="kid1NarcoticsYear"
                              #kid1NarcoticsYear="ngModel" pattern="^((?!(0))[0-9]{1,10}\d*)$" inputmode="numeric">
                          </div>
                          <div class="form-group">
                            <input type="text" name="kid1NarcoticsQuantity" id="kid1NarcoticsQuantity"
                              class="form-control" placeholder="Quantity"
                              [(ngModel)]="proposal.insurerConsumeNarcoticsQuantity3" #kid1NarcoticsQuantity="ngModel"
                              (keydown.space)="$event.preventDefault();" pattern="^((?!(0))[0-9]{1,10}\d*)$"
                              inputmode="numeric">
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-6">
                      <div class="row">
                        <div class="col">
                          <span class="title" style="display:block">Alcohol</span>
                          <input type="radio" value="No" name="kid1Alcohol"
                            [(ngModel)]="proposal.insurerConsumeAlcohol3"><span class="mr80 ml-2 mr-2">No</span>
                          <input type="radio" name="kid1Alcohol" [(ngModel)]="proposal.insurerConsumeAlcohol3"
                            value="Yes" [checked]="proposal.kid1Alcohol"><span class="ml-2">Yes</span>
                        </div>
                      </div>
                      <div class="row" *ngIf="proposal.insurerConsumeAlcohol3 === 'Yes'">
                        <div class="col mt-3">
                          <div class="form-group">
                            <input type="text" class="form-control" placeholder="Since Years" name="kid1AlcoholYear"
                              [(ngModel)]="proposal.insurerConsumeAlcoholNumberOfYear3" id="kid1AlcoholYear"
                              #kid1AlcoholYear="ngModel" pattern="^((?!(0))[0-9]{1,10}\d*)$" inputmode="numeric">
                          </div>
                          <div class="form-group">
                            <input type="text" name="kid1AlcoholYear" id="kid1AlcoholYear" class="form-control"
                              placeholder="Quantity" [(ngModel)]="proposal.insurerConsumeAlcoholQuantity3"
                              #kid1AlcoholYear="ngModel" (keydown.space)="$event.preventDefault();"
                              pattern="^((?!(0))[0-9]{1,10}\d*)$" inputmode="numeric">
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-6">
                      <div class="row">
                        <div class="col">
                          <span class="title" style="display:block">Tobacco/Guthka, etc</span>
                          <input type="radio" value="No" name="kid1Tobacco"
                            [(ngModel)]="proposal.insurerConsumeTobacco3"><span class="mr80 ml-2 mr-2">No</span>
                          <input type="radio" name="kid1Tobacco" [(ngModel)]="proposal.insurerConsumeTobacco3"
                            value="Yes" [checked]="proposal.kid1Tobacco"><span class="ml-2">Yes</span>
                        </div>
                      </div>
                      <div class="row" *ngIf="proposal.insurerConsumeTobacco3 === 'Yes'">
                        <div class="col mt-3">
                          <div class="form-group">
                            <input type="text" class="form-control" placeholder="Since Years" name="kid1TobaccoYear"
                              [(ngModel)]="proposal.insurerTobaccoNumberOfYear3" id="kid1TobaccoYear"
                              #kid1TobaccoYear="ngModel" pattern="^((?!(0))[0-9]{1,10}\d*)$" inputmode="numeric">
                          </div>
                          <div class="form-group">
                            <input type="text" name="kid1TobaccoDays" id="kid1TobaccoDays" class="form-control"
                              placeholder="No. of packs(In a day)" [(ngModel)]="proposal.insurerTobaccoQuantity3"
                              #kid1TobaccoDays="ngModel" (keydown.space)="$event.preventDefault();"
                              pattern="^((?!(0))[0-9]{1,10}\d*)$" inputmode="numeric">
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row mt-4">

                    <div class="col-12 text-center">
                      <button class="btn btn-bordered-blue" (click)="nextStep('2')">Next</button>
                    </div>
                  </div>
                </div>
                <div id="kid2" class="container tab-pane fade"><br>
                  <form name="form" #proposalFormTabTwo3="ngForm">
                    <div class="row">
                      <div class="col-md-12">
                        <div class="form-group">
                          <select class="form-control" name="insurerMemberRelation4"
                            [(ngModel)]="proposal.insurerMemberRelation4">
                            <option value="SON">SON</option>
                            <option value="DAUGHTER">DAUGHTER</option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-2 pr-0">
                        <p class="title mendatory">Title</p>
                        <div class="sum-insured-input">
                          <div class="form-group">
                            <select class="form-control" name="kid2Title" [(ngModel)]="proposal.insuredPersonGender4"
                              id="kid2Title" #kid2Title="ngModel">
                              <option value="M">Mr</option>
                              <option value="F">Mrs</option>
                              <option value="F">Ms</option>
                            </select>
                          </div>
                        </div>
                      </div>
                      <div class="col-5">
                        <p class="title mendatory">First Name</p>
                        <div class="sum-insured-input">
                          <div class="form-group">
                            <input class="form-control" type="text" name="kid2FirstName"
                              [(ngModel)]="proposal.insuredPersonFirstName4" id="kid2FirstName" #kid2FirstName="ngModel"
                              pattern="[a-zA-Z]+" maxlength="200">
                          </div>
                        </div>
                      </div>
                      <div class="col-5">
                        <p class="title mendatory">Last Name</p>
                        <div class="sum-insured-input">
                          <div class="form-group">
                            <input class="form-control" type="text" name="kid2LastName"
                              [(ngModel)]="proposal.insuredPersonLastName4" id="kid2LastName" #kid2LastName="ngModel"
                              pattern="[a-zA-Z\s]+" maxlength="200">
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12">
                        <p class="title mendatory">Date of Birth</p>
                        <div class="sum-insured-input reg-date-input reg-date-input1">
                          <div class="input-group form-group">
                            <div class="input-group addon">
                              <img
                                src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/common-icons/Date.svg">
                              <p-calendar [touchUI]="true" [readonlyInput]="true" [(ngModel)]="proposal.insurerDob4"
                                dateFormat="dd/mm/yy" [monthNavigator]="true" [yearNavigator]="true"
                                yearRange="1960:{{currentDate.getFullYear()}}" placeholder="Date" name="regDate" [maxDate]="currentDate"
                                (onSelect)="calculateAge()" keepInvalid></p-calendar>
                              <span class="input-group-addon" id="basic-addon-dueDate"></span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-6">
                        <p class="title">Height (in meters)</p>
                        <div class="sum-insured-input">
                          <div class="form-group">
                            <input class="form-control" type="text" (keyup)="calculateBmi('4')" name="kid2Height"
                              #kid2Height="ngModel" [(ngModel)]="proposal.height4">
                          </div>
                        </div>
                      </div>
                      <div class="col-6">
                        <p class="title">Weight (Kg)</p>
                        <div class="sum-insured-input">
                          <div class="form-group">
                            <input class="form-control" type="text" (keyup)="calculateBmi('4')" name="kid2Weight"
                              #kid2Weight="ngModel" [(ngModel)]="proposal.weight4" pattern="^\d{4}\d{4}\d{4}$">
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12">
                        <p class="title mendatory">Occupation</p>
                        <div class="sum-insured-input">
                          <div class="form-group">
                            <select class="form-control long-text" id="kid2Occupation" name="kid2Occupation"
                              [(ngModel)]="proposal.occupation4" required #kid2Occupation="ngModel">
                              <option selected="" disabled="" value="">OCCUPATION</option>
                              <option value="SALARIED">SALARIED</option>
                              <option value="SELF EMPLOYED">SELF EMPLOYED</option>
                              <option value="HOUSEWIFE">HOUSE WIFE</option>
                              <option value="STUDENT">STUDENT</option>
                              <option value="OTHERS">OTHERS</option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row" *ngIf="proposal.occupation4 === 'SALARIED' || proposal.occupation4 === 'OTHERS'">
                      <div class="col-12">
                        <p class="title mendatory">Designation</p>
                        <input class="form-control" required type="text" name="designation4"
                          [(ngModel)]="proposal.designation4" />
                      </div>
                    </div>
                    <div class="row" *ngIf="proposal.occupation4 === 'SELF EMPLOYED'">
                      <div class="col-12">
                        <p class="title mendatory">Business</p>
                        <input class="form-control" required type="text" name="business4"
                          [(ngModel)]="proposal.business4" />
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-6">
                        <div class="row">
                          <div class="col">
                            <span class="title" style="display:block">Smoke</span>
                            <input type="radio" value="No" name="kid2Smoke" [(ngModel)]="proposal.smokingInsurer4"><span
                              class="mr80 ml-2 mr-2">No</span>
                            <input type="radio" name="kid2Smoke" [(ngModel)]="proposal.smokingInsurer4" value="Yes"
                              [checked]="proposal.kid2Smoke"><span class="ml-2">Yes</span>
                          </div>
                        </div>
                        <div class="row" *ngIf="proposal.smokingInsurer4 === 'Yes'">
                          <div class="col mt-3">
                            <div class="form-group">
                              <input type="text" class="form-control" placeholder="Since Years" name="kid2SmokeYear"
                                [(ngModel)]="proposal.insurerSmokingNumberOfYear4" id="kid2SmokeYear"
                                #kid2SmokeYear="ngModel" pattern="^((?!(0))[0-9]{1,10}\d*)$" inputmode="numeric">
                            </div>
                            <div class="form-group">
                              <input type="text" name="kid2SmokeDays" id="kid2SmokeDays" class="form-control"
                                placeholder="No. (In a day)" [(ngModel)]="proposal.insurerSmokingQuantity4"
                                #kid2SmokeDays="ngModel" (keydown.space)="$event.preventDefault();"
                                pattern="^((?!(0))[0-9]{1,10}\d*)$" inputmode="numeric">
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-6">
                        <div class="row">
                          <div class="col">
                            <span class="title" style="display:block">Narcotics</span>
                            <input type="radio" value="No" name="kid2Narcotics"
                              [(ngModel)]="proposal.insurerConsumeNarcotics4"><span class="mr80 ml-2 mr-2">No</span>
                            <input type="radio" name="kid2Narcotics" [(ngModel)]="proposal.insurerConsumeNarcotics4"
                              value="Yes" [checked]="proposal.kid2Narcotics"><span class="ml-2">Yes</span>
                          </div>
                        </div>
                        <div class="row" *ngIf="proposal.insurerConsumeNarcotics4 === 'Yes'">
                          <div class="col mt-3">
                            <div class="form-group">
                              <input type="text" class="form-control" placeholder="Since Years" name="kid2NarcoticsYear"
                                [(ngModel)]="proposal.insurerConsumeNarcoticsNumberOfYear4" id="kid2NarcoticsYear"
                                #kid2NarcoticsYear="ngModel" pattern="^((?!(0))[0-9]{1,10}\d*)$" inputmode="numeric">
                            </div>
                            <div class="form-group">
                              <input type="text" name="kid2NarcoticsQuantity" id="kid2NarcoticsQuantity"
                                class="form-control" placeholder="Quantity"
                                [(ngModel)]="proposal.insurerConsumeNarcoticsQuantity4" #kid2NarcoticsQuantity="ngModel"
                                (keydown.space)="$event.preventDefault();" pattern="^((?!(0))[0-9]{1,10}\d*)$"
                                inputmode="numeric">
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-6">
                        <div class="row">
                          <div class="col">
                            <span class="title" style="display:block">Alcohol</span>
                            <input type="radio" value="No" name="kid2Alcohol"
                              [(ngModel)]="proposal.insurerConsumeAlcohol4"><span class="mr80 ml-2 mr-2">No</span>
                            <input type="radio" name="kid2Alcohol" [(ngModel)]="proposal.insurerConsumeAlcohol4"
                              value="Yes" [checked]="proposal.kid2Alcohol"><span class="ml-2">Yes</span>
                          </div>
                        </div>
                        <div class="row" *ngIf="proposal.insurerConsumeAlcohol4 === 'Yes'">
                          <div class="col mt-3">
                            <div class="form-group">
                              <input type="text" class="form-control" placeholder="Since Years" name="kid2AlcoholYear"
                                [(ngModel)]="proposal.insurerConsumeAlcoholNumberOfYear4" id="kid2AlcoholYear"
                                #kid2AlcoholYear="ngModel" pattern="^((?!(0))[0-9]{1,10}\d*)$" inputmode="numeric">
                            </div>
                            <div class="form-group">
                              <input type="text" name="kid2AlcoholYear" id="kid2AlcoholYear" class="form-control"
                                placeholder="Quantity" [(ngModel)]="proposal.insurerConsumeAlcoholQuantity4"
                                #kid2AlcoholYear="ngModel" (keydown.space)="$event.preventDefault();"
                                pattern="^((?!(0))[0-9]{1,10}\d*)$" inputmode="numeric">
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-6">
                        <div class="row">
                          <div class="col">
                            <span class="title" style="display:block">Tobacco/Guthka, etc</span>
                            <input type="radio" value="No" name="kid2Tobacco"
                              [(ngModel)]="proposal.insurerConsumeTobacco4"><span class="mr80 ml-2 mr-2">No</span>
                            <input type="radio" name="kid2Tobacco" [(ngModel)]="proposal.insurerConsumeTobacco4"
                              value="Yes" [checked]="proposal.kid2Tobacco"><span class="ml-2">Yes</span>
                          </div>
                        </div>
                        <div class="row" *ngIf="proposal.insurerConsumeTobacco4 === 'Yes'">
                          <div class="col mt-3">
                            <div class="form-group">
                              <input type="text" class="form-control" placeholder="Since Years" name="kid2TobaccoYear"
                                [(ngModel)]="proposal.insurerTobaccoNumberOfYear4" id="kid2TobaccoYear"
                                #kid2TobaccoYear="ngModel" pattern="^((?!(0))[0-9]{1,10}\d*)$" inputmode="numeric">
                            </div>
                            <div class="form-group">
                              <input type="text" name="kid2TobaccoDays" id="kid2TobaccoDays" class="form-control"
                                placeholder="No. of packs(In a day)" [(ngModel)]="proposal.insurerTobaccoQuantity4"
                                #kid2TobaccoDays="ngModel" (keydown.space)="$event.preventDefault();"
                                pattern="^((?!(0))[0-9]{1,10}\d*)$" inputmode="numeric">
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row mt-4">

                      <div class="col-12 text-center">
                        <button class="btn btn-bordered-blue" (click)="nextStep('2')">Next</button>
                      </div>
                    </div>
                  </form>
                </div>
                <div id="kid3" class="container tab-pane fade"><br>
                  <form name="form" #proposalFormTabTwo4="ngForm">
                    <div class="row">
                      <div class="col-md-12">
                        <div class="form-group">
                          <select class="form-control" name="insurerMemberRelation5"
                            [(ngModel)]="proposal.insurerMemberRelation5">
                            <option value="SON">SON</option>
                            <option value="DAUGHTER">DAUGHTER</option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-2 pr-0">
                        <p class="title mendatory">Title</p>
                        <div class="sum-insured-input">
                          <div class="form-group">
                            <select class="form-control" name="kid3Title" [(ngModel)]="proposal.insuredPersonGender5"
                              id="kid3Title" #kid3Title="ngModel">
                              <option value="M">Mr</option>
                              <option value="F">Mrs</option>
                              <option value="F">Ms</option>
                            </select>
                          </div>
                        </div>
                      </div>
                      <div class="col-5">
                        <p class="title mendatory">First Name</p>
                        <div class="sum-insured-input">
                          <div class="form-group">
                            <input class="form-control" type="text" name="kid3FirstName"
                              [(ngModel)]="proposal.insuredPersonFirstName5" id="kid3FirstName" #kid3FirstName="ngModel"
                              pattern="[a-zA-Z]+" maxlength="200">
                          </div>
                        </div>
                      </div>
                      <div class="col-5">
                        <p class="title mendatory">Last Name</p>
                        <div class="sum-insured-input">
                          <div class="form-group">
                            <input class="form-control" type="text" name="kid3LastName"
                              [(ngModel)]="proposal.insuredPersonLastName5" id="kid3LastName" #kid3LastName="ngModel"
                              pattern="[a-zA-Z\s]+" maxlength="200">
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12">
                        <p class="title mendatory">Date of Birth</p>
                        <div class="sum-insured-input reg-date-input reg-date-input1">
                          <div class="input-group form-group">
                            <div class="input-group addon">
                              <img
                                src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/common-icons/Date.svg">
                              <p-calendar [touchUI]="true" [readonlyInput]="true" [(ngModel)]="proposal.insurerDob5"
                                dateFormat="dd/mm/yy" [monthNavigator]="true" [yearNavigator]="true"
                                yearRange="1960:{{currentDate.getFullYear()}}" placeholder="Date" name="regDate" [maxDate]="currentDate"
                                (onSelect)="calculateAge()" keepInvalid></p-calendar>
                              <span class="input-group-addon" id="basic-addon-dueDate"></span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-6">
                        <p class="title">Height (in meters)</p>
                        <div class="sum-insured-input">
                          <div class="form-group">
                            <input class="form-control" type="text" (keyup)="calculateBmi('5')" name="kid3Height"
                              #kid3Height="ngModel" [(ngModel)]="proposal.height5">
                          </div>
                        </div>
                      </div>
                      <div class="col-6">
                        <p class="title">Weight (Kg)</p>
                        <div class="sum-insured-input">
                          <div class="form-group">
                            <input class="form-control" type="text" (keyup)="calculateBmi('5')" name="kid3Weight"
                              #kid3Weight="ngModel" [(ngModel)]="proposal.weight5" pattern="^\d{4}\d{4}\d{4}$">
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12">
                        <p class="title mendatory">Occupation</p>
                        <div class="sum-insured-input">
                          <div class="form-group">
                            <select class="form-control long-text" id="kid3Occupation" name="kid3Occupation"
                              [(ngModel)]="proposal.occupation5" required #kid3Occupation="ngModel">
                              <option selected="" disabled="" value="">OCCUPATION</option>
                              <option value="SALARIED">SALARIED</option>
                              <option value="SELF EMPLOYED">SELF EMPLOYED</option>
                              <option value="HOUSEWIFE">HOUSE WIFE</option>
                              <option value="STUDENT">STUDENT</option>
                              <option value="OTHERS">OTHERS</option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row" *ngIf="proposal.occupation5 === 'SALARIED' || proposal.occupation5 === 'OTHERS'">
                      <div class="col-12">
                        <p class="title mendatory">Designation</p>
                        <input class="form-control" required type="text" name="designation5"
                          [(ngModel)]="proposal.designation5" />
                      </div>
                    </div>
                    <div class="row" *ngIf="proposal.occupation5 === 'SELF EMPLOYED'">
                      <div class="col-12">
                        <p class="title mendatory">Business</p>
                        <input class="form-control" required type="text" name="business5"
                          [(ngModel)]="proposal.business5" />
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-6">
                        <div class="row">
                          <div class="col">
                            <span class="title" style="display:block">Smoke</span>
                            <input type="radio" value="No" name="kid3Smoke" [(ngModel)]="proposal.smokingInsurer5"><span
                              class="mr80 ml-2 mr-2">No</span>
                            <input type="radio" name="kid3Smoke" [(ngModel)]="proposal.smokingInsurer5" value="yes"
                              [checked]="proposal.kid3Smoke"><span class="ml-2">Yes</span>
                          </div>
                        </div>
                        <div class="row" *ngIf="proposal.smokingInsurer5 === 'Yes'">
                          <div class="col mt-3">
                            <div class="form-group">
                              <input type="text" class="form-control" placeholder="Since Years" name="kid3SmokeYear"
                                [(ngModel)]="proposal.insurerSmokingNumberOfYear5" id="kid3SmokeYear"
                                #kid3SmokeYear="ngModel" pattern="^((?!(0))[0-9]{1,10}\d*)$" inputmode="numeric">
                            </div>
                            <div class="form-group">
                              <input type="text" name="kid3SmokeDays" id="kid3SmokeDays" class="form-control"
                                placeholder="No. (In a day)" [(ngModel)]="proposal.insurerSmokingQuantity5"
                                #kid3SmokeDays="ngModel" (keydown.space)="$event.preventDefault();"
                                pattern="^((?!(0))[0-9]{1,10}\d*)$" inputmode="numeric">
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-6">
                        <div class="row">
                          <div class="col">
                            <span class="title" style="display:block">Narcotics</span>
                            <input type="radio" value="No" name="kid3Narcotics"
                              [(ngModel)]="proposal.insurerConsumeNarcotics5"><span class="mr80 ml-2 mr-2">No</span>
                            <input type="radio" name="kid3Narcotics" [(ngModel)]="proposal.insurerConsumeNarcotics5"
                              value="Yes" [checked]="proposal.kid3Narcotics"><span class="ml-2">Yes</span>
                          </div>
                        </div>
                        <div class="row" *ngIf="proposal.insurerConsumeNarcotics5 === 'Yes'">
                          <div class="col mt-3">
                            <div class="form-group">
                              <input type="text" class="form-control" placeholder="Since Years" name="kid3NarcoticsYear"
                                [(ngModel)]="proposal.insurerConsumeNarcoticsNumberOfYear5" id="kid3NarcoticsYear"
                                #kid3NarcoticsYear="ngModel" pattern="^((?!(0))[0-9]{1,10}\d*)$" inputmode="numeric">
                            </div>
                            <div class="form-group">
                              <input type="text" name="kid3NarcoticsQuantity" id="kid3NarcoticsQuantity"
                                class="form-control" placeholder="Quantity"
                                [(ngModel)]="proposal.insurerConsumeNarcoticsQuantity5" #kid3NarcoticsQuantity="ngModel"
                                (keydown.space)="$event.preventDefault();" pattern="^((?!(0))[0-9]{1,10}\d*)$"
                                inputmode="numeric">
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-6">
                        <div class="row">
                          <div class="col">
                            <span class="title" style="display:block">Alcohol</span>
                            <input type="radio" value="No" name="kid3Alcohol"
                              [(ngModel)]="proposal.insurerConsumeAlcohol5"><span class="mr80 ml-2 mr-2">No</span>
                            <input type="radio" name="kid3Alcohol" [(ngModel)]="proposal.insurerConsumeAlcohol5"
                              value="Yes" [checked]="proposal.kid3Alcohol"><span class="ml-2">Yes</span>
                          </div>
                        </div>
                        <div class="row" *ngIf="proposal.insurerConsumeAlcohol5 === 'Yes'">
                          <div class="col mt-3">
                            <div class="form-group">
                              <input type="text" class="form-control" placeholder="Since Years" name="kid3AlcoholYear"
                                [(ngModel)]="proposal.insurerConsumeAlcoholNumberOfYear5" id="kid3AlcoholYear"
                                #kid3AlcoholYear="ngModel" pattern="^((?!(0))[0-9]{1,10}\d*)$" inputmode="numeric">
                            </div>
                            <div class="form-group">
                              <input type="text" name="kid3AlcoholYear" id="kid3AlcoholYear" class="form-control"
                                placeholder="Quantity" [(ngModel)]="proposal.insurerConsumeAlcoholQuantity5"
                                #kid3AlcoholYear="ngModel" (keydown.space)="$event.preventDefault();"
                                pattern="^((?!(0))[0-9]{1,10}\d*)$" inputmode="numeric">
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-6">
                        <div class="row">
                          <div class="col">
                            <span class="title" style="display:block">Tobacco/Guthka, etc</span>
                            <input type="radio" value="No" name="kid3Tobacco"
                              [(ngModel)]="proposal.insurerConsumeTobacco5"><span class="mr80 ml-2 mr-2">No</span>
                            <input type="radio" name="kid3Tobacco" [(ngModel)]="proposal.insurerConsumeTobacco5"
                              value="Yes" [checked]="proposal.kid3Tobacco"><span class="ml-2">Yes</span>
                          </div>
                        </div>
                        <div class="row" *ngIf="proposal.insurerConsumeTobacco5 === 'Yes'">
                          <div class="col mt-3">
                            <div class="form-group">
                              <input type="text" class="form-control" placeholder="Since Years" name="kid3TobaccoYear"
                                [(ngModel)]="proposal.insurerTobaccoNumberOfYear5" id="kid3TobaccoYear"
                                #kid3TobaccoYear="ngModel" pattern="^((?!(0))[0-9]{1,10}\d*)$" inputmode="numeric">
                            </div>
                            <div class="form-group">
                              <input type="text" name="kid3TobaccoDays" id="kid3TobaccoDays" class="form-control"
                                placeholder="No. of packs(In a day)" [(ngModel)]="proposal.insurerTobaccoQuantity5"
                                #kid3TobaccoDays="ngModel" (keydown.space)="$event.preventDefault();"
                                pattern="^((?!(0))[0-9]{1,10}\d*)$" inputmode="numeric">
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row mt-4">
                      <div class="col-12 text-center">
                        <button class="btn btn-bordered-blue" (click)="nextStep('2')">Next</button>
                      </div>
                    </div>
                  </form>
                </div>
              </ng-container>
              <!--if no spouse-->
              <ng-container *ngIf="!quoteDetails.isspouse">
                <div id="kid1" class="container tab-pane fade"><br>
                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <select class="form-control" name="insurerMemberRelation2"
                          [(ngModel)]="proposal.insurerMemberRelation2">
                          <option value="SON">SON</option>
                          <option value="DAUGHTER">DAUGHTER</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-2 pr-0">
                      <p class="title mendatory">Title</p>
                      <div class="sum-insured-input">
                        <div class="form-group">
                          <select class="form-control" name="kid1Title" [(ngModel)]="proposal.insuredPersonGender2"
                            id="kid1Title" #kid1Title="ngModel">
                            <option value="M">Mr</option>
                            <option value="F">Mrs</option>
                            <option value="F">Ms</option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div class="col-5">
                      <p class="title mendatory">First Name</p>
                      <div class="sum-insured-input">
                        <div class="form-group">
                          <input class="form-control" type="text" name="kid1FirstName"
                            [(ngModel)]="proposal.insuredPersonFirstName2" id="kid1FirstName" #kid1FirstName="ngModel"
                            pattern="[a-zA-Z]+" maxlength="200">
                        </div>
                      </div>
                    </div>
                    <div class="col-5">
                      <p class="title mendatory">Last Name</p>
                      <div class="sum-insured-input">
                        <div class="form-group">
                          <input class="form-control" type="text" name="kid1LastName"
                            [(ngModel)]="proposal.insuredPersonLastName2" id="kid1LastName" #kid1LastName="ngModel"
                            pattern="[a-zA-Z\s]+" maxlength="200">
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12">
                      <p class="title mendatory">Date of Birth</p>
                      <div class="sum-insured-input reg-date-input reg-date-input1">
                        <div class="input-group form-group">
                          <div class="input-group addon">
                            <img
                              src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/common-icons/Date.svg">
                            <p-calendar [touchUI]="true" [readonlyInput]="true" [(ngModel)]="proposal.insurerDob2"
                              dateFormat="dd/mm/yy" [monthNavigator]="true" [yearNavigator]="true" yearRange="1960:{{currentDate.getFullYear()}}"
                              placeholder="Date" name="regDate" [maxDate]="currentDate" (onBlur)="checkValue()"
                              (onSelect)="calculateAge()" keepInvalid></p-calendar>
                            <span class="input-group-addon" id="basic-addon-dueDate"></span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-6">
                      <p class="title">Height (in meters)</p>
                      <div class="sum-insured-input">
                        <div class="form-group">
                          <input class="form-control" type="text" (keyup)="calculateBmi('2')" name="kid1Height"
                            #kid1Height="ngModel" [(ngModel)]="proposal.height2">
                        </div>
                      </div>
                    </div>
                    <div class="col-6">
                      <p class="title">Weight (Kg)</p>
                      <div class="sum-insured-input">
                        <div class="form-group">
                          <input class="form-control" type="text" (keyup)="calculateBmi('2')" name="kid1Weight"
                            #kid1Weight="ngModel" [(ngModel)]="proposal.weight2" pattern="^\d{4}\d{4}\d{4}$">
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12">
                      <p class="title mendatory">Occupation</p>
                      <div class="sum-insured-input">
                        <div class="form-group">
                          <select class="form-control long-text" id="kid1Occupation" name="kid1Occupation"
                            [(ngModel)]="proposal.occupation2" required #kid1Occupation="ngModel">
                            <option selected="" disabled="" value="">OCCUPATION</option>
                            <option value="SALARIED">SALARIED</option>
                            <option value="SELF EMPLOYED">SELF EMPLOYED</option>
                            <option value="HOUSEWIFE">HOUSE WIFE</option>
                            <option value="STUDENT">STUDENT</option>
                            <option value="OTHERS">OTHERS</option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row" *ngIf="proposal.occupation2 === 'SALARIED' || proposal.occupation2 === 'OTHERS'">
                    <div class="col-12">
                      <p class="title mendatory">Designation</p>
                      <input class="form-control" required type="text" name="designation2"
                        [(ngModel)]="proposal.designation2" />
                    </div>
                  </div>
                  <div class="row" *ngIf="proposal.occupation2 === 'SELF EMPLOYED'">
                    <div class="col-12">
                      <p class="title mendatory">Business</p>
                      <input class="form-control" required type="text" name="business2"
                        [(ngModel)]="proposal.business2" />
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-6">
                      <div class="row">
                        <div class="col">
                          <span class="title" style="display:block">Smoke</span>
                          <input type="radio" name="kid1Smoke" value="No" [(ngModel)]="proposal.smokingInsurer2"><span
                            class="mr80 ml-2 mr-2">No</span>
                          <input type="radio" name="kid1Smoke" [(ngModel)]="proposal.smokingInsurer2" value="Yes"
                            [checked]="proposal.kid1Smoke"><span class="ml-2">Yes</span>
                        </div>
                      </div>
                      <div class="row" *ngIf="proposal.smokingInsurer2 === 'Yes'">
                        <div class="col mt-3">
                          <div class="form-group">
                            <input type="text" class="form-control" placeholder="Since Years" name="kid1SmokeYear"
                              [(ngModel)]="proposal.insurerSmokingNumberOfYear2" id="kid1SmokeYear"
                              #kid1SmokeYear="ngModel" pattern="^((?!(0))[0-9]{1,10}\d*)$" inputmode="numeric">
                          </div>
                          <div class="form-group">
                            <input type="text" name="kid1SmokeDays" id="kid1SmokeDays" class="form-control"
                              placeholder="No. (In a day)" [(ngModel)]="proposal.insurerSmokingQuantity2"
                              #kid1SmokeDays="ngModel" (keydown.space)="$event.preventDefault();"
                              pattern="^((?!(0))[0-9]{1,10}\d*)$" inputmode="numeric">
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-6">
                      <div class="row">
                        <div class="col">
                          <span class="title" style="display:block">Narcotics</span>
                          <input type="radio" value="No" name="kid1Narcotics"
                            [(ngModel)]="proposal.insurerConsumeNarcotics2"><span class="mr80 ml-2 mr-2">No</span>
                          <input type="radio" name="kid1Narcotics" [(ngModel)]="proposal.insurerConsumeNarcotics3"
                            value="Yes" [checked]="proposal.kid1Narcotics"><span class="ml-2">Yes</span>
                        </div>
                      </div>
                      <div class="row" *ngIf="proposal.insurerConsumeNarcotics2 === 'Yes'">
                        <div class="col mt-3">
                          <div class="form-group">
                            <input type="text" class="form-control" placeholder="Since Years" name="kid1NarcoticsYear"
                              [(ngModel)]="proposal.insurerConsumeNarcoticsNumberOfYear2" id="kid1NarcoticsYear"
                              #kid1NarcoticsYear="ngModel" pattern="^((?!(0))[0-9]{1,10}\d*)$" inputmode="numeric">
                          </div>
                          <div class="form-group">
                            <input type="text" name="kid1NarcoticsQuantity" id="kid1NarcoticsQuantity"
                              class="form-control" placeholder="Quantity"
                              [(ngModel)]="proposal.insurerConsumeNarcoticsQuantity2" #kid1NarcoticsQuantity="ngModel"
                              (keydown.space)="$event.preventDefault();" pattern="^((?!(0))[0-9]{1,10}\d*)$"
                              inputmode="numeric">
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-6">
                      <div class="row">
                        <div class="col">
                          <span class="title" style="display:block">Alcohol</span>
                          <input type="radio" value="No" name="kid1Alcohol"
                            [(ngModel)]="proposal.insurerConsumeAlcohol2"><span class="mr80 ml-2 mr-2">No</span>
                          <input type="radio" name="kid1Alcohol" [(ngModel)]="proposal.insurerConsumeAlcohol3"
                            value="Yes" [checked]="proposal.kid1Alcohol"><span class="ml-2">Yes</span>
                        </div>
                      </div>
                      <div class="row" *ngIf="proposal.insurerConsumeAlcohol2 === 'Yes'">
                        <div class="col mt-3">
                          <div class="form-group">
                            <input type="text" class="form-control" placeholder="Since Years" name="kid1AlcoholYear"
                              [(ngModel)]="proposal.insurerConsumeAlcoholNumberOfYear2" id="kid1AlcoholYear"
                              #kid1AlcoholYear="ngModel" pattern="^((?!(0))[0-9]{1,10}\d*)$" inputmode="numeric">
                          </div>
                          <div class="form-group">
                            <input type="text" name="kid1AlcoholYear" id="kid1AlcoholYear" class="form-control"
                              placeholder="Quantity" [(ngModel)]="proposal.insurerConsumeAlcoholQuantity2"
                              #kid1AlcoholYear="ngModel" (keydown.space)="$event.preventDefault();"
                              pattern="^((?!(0))[0-9]{1,10}\d*)$" inputmode="numeric">
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-6">
                      <div class="row">
                        <div class="col">
                          <span class="title" style="display:block">Tobacco/Guthka, etc</span>
                          <input type="radio" value="No" name="kid1Tobacco"
                            [(ngModel)]="proposal.insurerConsumeTobacco2"><span class="mr80 ml-2 mr-2">No</span>
                          <input type="radio" name="kid1Tobacco" [(ngModel)]="proposal.insurerConsumeTobacco3"
                            value="Yes" [checked]="proposal.kid1Tobacco"><span class="ml-2">Yes</span>
                        </div>
                      </div>
                      <div class="row" *ngIf="proposal.insurerConsumeTobacco2 === 'Yes'">
                        <div class="col mt-3">
                          <div class="form-group">
                            <input type="text" class="form-control" placeholder="Since Years" name="kid1TobaccoYear"
                              [(ngModel)]="proposal.insurerTobaccoNumberOfYear2" id="kid1TobaccoYear"
                              #kid1TobaccoYear="ngModel" pattern="^((?!(0))[0-9]{1,10}\d*)$" inputmode="numeric">
                          </div>
                          <div class="form-group">
                            <input type="text" name="kid1TobaccoDays" id="kid1TobaccoDays" class="form-control"
                              placeholder="No. of packs(In a day)" [(ngModel)]="proposal.insurerTobaccoQuantity2"
                              #kid1TobaccoDays="ngModel" (keydown.space)="$event.preventDefault();"
                              pattern="^((?!(0))[0-9]{1,10}\d*)$" inputmode="numeric">
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row mt-4">

                    <div class="col-12 text-center">
                      <button class="btn btn-bordered-blue" (click)="nextStep('2')">Next</button>
                    </div>
                  </div>
                </div>
                <div id="kid2" class="container tab-pane fade"><br>
                  <form name="form" #proposalFormTabTwo3="ngForm">
                    <div class="row">
                      <div class="col-md-12">
                        <div class="form-group">
                          <select class="form-control" name="insurerMemberRelation3"
                            [(ngModel)]="proposal.insurerMemberRelation3">
                            <option value="SON">SON</option>
                            <option value="DAUGHTER">DAUGHTER</option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-2 pr-0">
                        <p class="title mendatory">Title</p>
                        <div class="sum-insured-input">
                          <div class="form-group">
                            <select class="form-control" name="kid2Title" [(ngModel)]="proposal.insuredPersonGender3"
                              id="kid2Title" #kid2Title="ngModel">
                              <option value="M">Mr</option>
                              <option value="F">Mrs</option>
                              <option value="F">Ms</option>
                            </select>
                          </div>
                        </div>
                      </div>
                      <div class="col-5">
                        <p class="title mendatory">First Name</p>
                        <div class="sum-insured-input">
                          <div class="form-group">
                            <input class="form-control" type="text" name="kid2FirstName"
                              [(ngModel)]="proposal.insuredPersonFirstName3" id="kid2FirstName" #kid2FirstName="ngModel"
                              pattern="[a-zA-Z]+" maxlength="200">
                          </div>
                        </div>
                      </div>
                      <div class="col-5">
                        <p class="title mendatory">Last Name</p>
                        <div class="sum-insured-input">
                          <div class="form-group">
                            <input class="form-control" type="text" name="kid2LastName"
                              [(ngModel)]="proposal.insuredPersonLastName3" id="kid2LastName" #kid2LastName="ngModel"
                              pattern="[a-zA-Z\s]+" maxlength="200">
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12">
                        <p class="title mendatory">Date of Birth</p>
                        <div class="sum-insured-input reg-date-input reg-date-input1">
                          <div class="input-group form-group">
                            <div class="input-group addon">
                              <img
                                src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/common-icons/Date.svg">
                              <p-calendar [touchUI]="true" [readonlyInput]="true" [(ngModel)]="proposal.insurerDob3"
                                dateFormat="dd/mm/yy" [monthNavigator]="true" [yearNavigator]="true"
                                yearRange="1960:{{currentDate.getFullYear()}}" placeholder="Date" name="regDate" [maxDate]="currentDate"
                                (onBlur)="checkValue()" (onSelect)="calculateAge()" keepInvalid></p-calendar>
                              <span class="input-group-addon" id="basic-addon-dueDate"></span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-6">
                        <p class="title">Height (in meters)</p>
                        <div class="sum-insured-input">
                          <div class="form-group">
                            <input class="form-control" type="text" (keyup)="calculateBmi('3')" name="kid2Height"
                              #kid2Height="ngModel" [(ngModel)]="proposal.height3">
                          </div>
                        </div>
                      </div>
                      <div class="col-6">
                        <p class="title">Weight (Kg)</p>
                        <div class="sum-insured-input">
                          <div class="form-group">
                            <input class="form-control" type="text" (keyup)="calculateBmi('3')" name="kid2Weight"
                              #kid2Weight="ngModel" [(ngModel)]="proposal.weight3" pattern="^\d{4}\d{4}\d{4}$">
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12">
                        <p class="title mendatory">Occupation</p>
                        <div class="sum-insured-input">
                          <div class="form-group">
                            <select class="form-control long-text" id="kid2Occupation" name="kid2Occupation"
                              [(ngModel)]="proposal.occupation3" required #kid2Occupation="ngModel">
                              <option selected="" disabled="" value="">OCCUPATION</option>
                              <option value="SALARIED">SALARIED</option>
                              <option value="SELF EMPLOYED">SELF EMPLOYED</option>
                              <option value="HOUSEWIFE">HOUSE WIFE</option>
                              <option value="STUDENT">STUDENT</option>
                              <option value="OTHERS">OTHERS</option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row" *ngIf="proposal.occupation3 === 'SALARIED' || proposal.occupation3 === 'OTHERS'">
                      <div class="col-12">
                        <p class="title mendatory">Designation</p>
                        <input class="form-control" required type="text" name="designation3"
                          [(ngModel)]="proposal.designation3" />
                      </div>
                    </div>
                    <div class="row" *ngIf="proposal.occupation3 === 'SELF EMPLOYED'">
                      <div class="col-12">
                        <p class="title mendatory">Business</p>
                        <input class="form-control" required type="text" name="business3"
                          [(ngModel)]="proposal.business3" />
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-6">
                        <div class="row">
                          <div class="col">
                            <span class="title" style="display:block">Smoke</span>
                            <input type="radio" value="No" name="kid2Smoke" [(ngModel)]="proposal.smokingInsurer3"><span
                              class="mr80 ml-2 mr-2">No</span>
                            <input type="radio" name="kid2Smoke" [(ngModel)]="proposal.smokingInsurer4" value="Yes"
                              [checked]="proposal.kid2Smoke"><span class="ml-2">Yes</span>
                          </div>
                        </div>
                        <div class="row" *ngIf="proposal.smokingInsurer3 === 'Yes'">
                          <div class="col mt-3">
                            <div class="form-group">
                              <input type="text" class="form-control" placeholder="Since Years" name="kid2SmokeYear"
                                [(ngModel)]="proposal.insurerSmokingNumberOfYear3" id="kid2SmokeYear"
                                #kid2SmokeYear="ngModel" pattern="^((?!(0))[0-9]{1,10}\d*)$" inputmode="numeric">
                            </div>
                            <div class="form-group">
                              <input type="text" name="kid2SmokeDays" id="kid2SmokeDays" class="form-control"
                                placeholder="No. (In a day)" [(ngModel)]="proposal.insurerSmokingQuantity3"
                                #kid2SmokeDays="ngModel" (keydown.space)="$event.preventDefault();"
                                pattern="^((?!(0))[0-9]{1,10}\d*)$" inputmode="numeric">
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-6">
                        <div class="row">
                          <div class="col">
                            <span class="title" style="display:block">Narcotics</span>
                            <input type="radio" value="No" name="kid2Narcotics"
                              [(ngModel)]="proposal.insurerConsumeNarcotics4"><span class="mr80 ml-2 mr-2">No</span>
                            <input type="radio" name="kid2Narcotics" [(ngModel)]="proposal.insurerConsumeNarcotics3"
                              value="Yes" [checked]="proposal.kid2Narcotics"><span class="ml-2">Yes</span>
                          </div>
                        </div>
                        <div class="row" *ngIf="proposal.insurerConsumeNarcotics3 === 'Yes'">
                          <div class="col mt-3">
                            <div class="form-group">
                              <input type="text" class="form-control" placeholder="Since Years" name="kid2NarcoticsYear"
                                [(ngModel)]="proposal.insurerConsumeNarcoticsNumberOfYear3" id="kid2NarcoticsYear"
                                #kid2NarcoticsYear="ngModel" pattern="^((?!(0))[0-9]{1,10}\d*)$" inputmode="numeric">
                            </div>
                            <div class="form-group">
                              <input type="text" name="kid2NarcoticsQuantity" id="kid2NarcoticsQuantity"
                                class="form-control" placeholder="Quantity"
                                [(ngModel)]="proposal.insurerConsumeNarcoticsQuantity3" #kid2NarcoticsQuantity="ngModel"
                                (keydown.space)="$event.preventDefault();" pattern="^((?!(0))[0-9]{1,10}\d*)$"
                                inputmode="numeric">
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-6">
                        <div class="row">
                          <div class="col">
                            <span class="title" style="display:block">Alcohol</span>
                            <input type="radio" value="No" name="kid2Alcohol"
                              [(ngModel)]="proposal.insurerConsumeAlcohol4"><span class="mr80 ml-2 mr-2">No</span>
                            <input type="radio" name="kid2Alcohol" [(ngModel)]="proposal.insurerConsumeAlcohol3"
                              value="Yes" [checked]="proposal.kid2Alcohol"><span class="ml-2">Yes</span>
                          </div>
                        </div>
                        <div class="row" *ngIf="proposal.insurerConsumeAlcohol3 === 'Yes'">
                          <div class="col mt-3">
                            <div class="form-group">
                              <input type="text" class="form-control" placeholder="Since Years" name="kid2AlcoholYear"
                                [(ngModel)]="proposal.insurerConsumeAlcoholNumberOfYear3" id="kid2AlcoholYear"
                                #kid2AlcoholYear="ngModel" pattern="^((?!(0))[0-9]{1,10}\d*)$" inputmode="numeric">
                            </div>
                            <div class="form-group">
                              <input type="text" name="kid2AlcoholYear" id="kid2AlcoholYear" class="form-control"
                                placeholder="Quantity" [(ngModel)]="proposal.insurerConsumeAlcoholQuantity3"
                                #kid2AlcoholYear="ngModel" (keydown.space)="$event.preventDefault();"
                                pattern="^((?!(0))[0-9]{1,10}\d*)$" inputmode="numeric">
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-6">
                        <div class="row">
                          <div class="col">
                            <span class="title" style="display:block">Tobacco/Guthka, etc</span>
                            <input type="radio" value="No" name="kid2Tobacco"
                              [(ngModel)]="proposal.insurerConsumeTobacco4"><span class="mr80 ml-2 mr-2">No</span>
                            <input type="radio" name="kid2Tobacco" [(ngModel)]="proposal.insurerConsumeTobacco3"
                              value="Yes" [checked]="proposal.kid2Tobacco"><span class="ml-2">Yes</span>
                          </div>
                        </div>
                        <div class="row" *ngIf="proposal.insurerConsumeTobacco3 === 'Yes'">
                          <div class="col mt-3">
                            <div class="form-group">
                              <input type="text" class="form-control" placeholder="Since Years" name="kid2TobaccoYear"
                                [(ngModel)]="proposal.insurerTobaccoNumberOfYear3" id="kid2TobaccoYear"
                                #kid2TobaccoYear="ngModel" pattern="^((?!(0))[0-9]{1,10}\d*)$" inputmode="numeric">
                            </div>
                            <div class="form-group">
                              <input type="text" name="kid2TobaccoDays" id="kid2TobaccoDays" class="form-control"
                                placeholder="No. of packs(In a day)" [(ngModel)]="proposal.insurerTobaccoQuantity3"
                                #kid2TobaccoDays="ngModel" (keydown.space)="$event.preventDefault();"
                                pattern="^((?!(0))[0-9]{1,10}\d*)$" inputmode="numeric">
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row mt-4">

                      <div class="col-12 text-center">
                        <button class="btn btn-bordered-blue" (click)="nextStep('2')">Next</button>
                      </div>
                    </div>
                  </form>
                </div>
                <div id="kid3" class="container tab-pane fade"><br>
                  <form name="form" #proposalFormTabTwo4="ngForm">
                    <div class="row">
                      <div class="col-md-12">
                        <div class="form-group">
                          <select class="form-control" name="insurerMemberRelation4"
                            [(ngModel)]="proposal.insurerMemberRelation4">
                            <option value="SON">SON</option>
                            <option value="DAUGHTER">DAUGHTER</option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-2 pr-0">
                        <p class="title mendatory">Title</p>
                        <div class="sum-insured-input">
                          <div class="form-group">
                            <select class="form-control" name="kid3Title" [(ngModel)]="proposal.insuredPersonGender4"
                              id="kid3Title" #kid3Title="ngModel">
                              <option value="M">Mr</option>
                              <option value="F">Mrs</option>
                              <option value="F">Ms</option>
                            </select>
                          </div>
                        </div>
                      </div>
                      <div class="col-5">
                        <p class="title mendatory">First Name</p>
                        <div class="sum-insured-input">
                          <div class="form-group">
                            <input class="form-control" type="text" name="kid3FirstName"
                              [(ngModel)]="proposal.insuredPersonFirstName4" id="kid3FirstName" #kid3FirstName="ngModel"
                              pattern="[a-zA-Z]+" maxlength="200">
                          </div>
                        </div>
                      </div>
                      <div class="col-5">
                        <p class="title mendatory">Last Name</p>
                        <div class="sum-insured-input">
                          <div class="form-group">
                            <input class="form-control" type="text" name="kid3LastName"
                              [(ngModel)]="proposal.insuredPersonLastName4" id="kid3LastName" #kid3LastName="ngModel"
                              pattern="[a-zA-Z\s]+" maxlength="200">
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12">
                        <p class="title mendatory">Date of Birth</p>
                        <div class="sum-insured-input reg-date-input reg-date-input1">
                          <div class="input-group form-group">
                            <div class="input-group addon">
                              <img
                                src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/common-icons/Date.svg">
                              <p-calendar [touchUI]="true" [readonlyInput]="true" [(ngModel)]="proposal.insurerDob4"
                                dateFormat="dd/mm/yy" [monthNavigator]="true" [yearNavigator]="true"
                                yearRange="1960:{{currentDate.getFullYear()}}" placeholder="Date" name="regDate" [maxDate]="currentDate"
                                (onBlur)="checkValue()" (onSelect)="calculateAge()" keepInvalid></p-calendar>
                              <span class="input-group-addon" id="basic-addon-dueDate"></span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-6">
                        <p class="title">Height (in meters)</p>
                        <div class="sum-insured-input">
                          <div class="form-group">
                            <input class="form-control" type="text" (keyup)="calculateBmi('4')" name="kid3Height"
                              #kid3Height="ngModel" [(ngModel)]="proposal.height4">
                          </div>
                        </div>
                      </div>
                      <div class="col-6">
                        <p class="title">Weight (Kg)</p>
                        <div class="sum-insured-input">
                          <div class="form-group">
                            <input class="form-control" type="text" (keyup)="calculateBmi('4')" name="kid3Weight"
                              #kid3Weight="ngModel" [(ngModel)]="proposal.weight4" pattern="^\d{4}\d{4}\d{4}$">
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12">
                        <p class="title mendatory">Occupation</p>
                        <div class="sum-insured-input">
                          <div class="form-group">
                            <select class="form-control long-text" id="kid3Occupation" name="kid3Occupation"
                              [(ngModel)]="proposal.occupation4" required #kid3Occupation="ngModel">
                              <option selected="" disabled="" value="">OCCUPATION</option>
                              <option value="SALARIED">SALARIED</option>
                              <option value="SELF EMPLOYED">SELF EMPLOYED</option>
                              <option value="HOUSEWIFE">HOUSE WIFE</option>
                              <option value="STUDENT">STUDENT</option>
                              <option value="OTHERS">OTHERS</option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row" *ngIf="proposal.occupation4 === 'SALARIED' || proposal.occupation4 === 'OTHERS'">
                      <div class="col-12">
                        <p class="title mendatory">Designation</p>
                        <input class="form-control" required type="text" name="designation4"
                          [(ngModel)]="proposal.designation4" />
                      </div>
                    </div>
                    <div class="row" *ngIf="proposal.occupation4 === 'SELF EMPLOYED'">
                      <div class="col-12">
                        <p class="title mendatory">Business</p>
                        <input class="form-control" required type="text" name="business4"
                          [(ngModel)]="proposal.business4" />
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-6">
                        <div class="row">
                          <div class="col">
                            <span class="title" style="display:block">Smoke</span>
                            <input type="radio" value="No" name="kid3Smoke" [(ngModel)]="proposal.smokingInsurer4"><span
                              class="mr80 ml-2 mr-2">No</span>
                            <input type="radio" name="kid3Smoke" [(ngModel)]="proposal.smokingInsurer5" value="yes"
                              [checked]="proposal.kid3Smoke"><span class="ml-2">Yes</span>
                          </div>
                        </div>
                        <div class="row" *ngIf="proposal.smokingInsurer4 === 'Yes'">
                          <div class="col mt-3">
                            <div class="form-group">
                              <input type="text" class="form-control" placeholder="Since Years" name="kid3SmokeYear"
                                [(ngModel)]="proposal.insurerSmokingNumberOfYear4" id="kid3SmokeYear"
                                #kid3SmokeYear="ngModel" pattern="^((?!(0))[0-9]{1,10}\d*)$" inputmode="numeric">
                            </div>
                            <div class="form-group">
                              <input type="text" name="kid3SmokeDays" id="kid3SmokeDays" class="form-control"
                                placeholder="No. (In a day)" [(ngModel)]="proposal.insurerSmokingQuantity4"
                                #kid3SmokeDays="ngModel" (keydown.space)="$event.preventDefault();"
                                pattern="^((?!(0))[0-9]{1,10}\d*)$" inputmode="numeric">
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-6">
                        <div class="row">
                          <div class="col">
                            <span class="title" style="display:block">Narcotics</span>
                            <input type="radio" value="No" name="kid3Narcotics"
                              [(ngModel)]="proposal.insurerConsumeNarcotics5"><span class="mr80 ml-2 mr-2">No</span>
                            <input type="radio" name="kid3Narcotics" [(ngModel)]="proposal.insurerConsumeNarcotics4"
                              value="Yes" [checked]="proposal.kid3Narcotics"><span class="ml-2">Yes</span>
                          </div>
                        </div>
                        <div class="row" *ngIf="proposal.insurerConsumeNarcotics4 === 'Yes'">
                          <div class="col mt-3">
                            <div class="form-group">
                              <input type="text" class="form-control" placeholder="Since Years" name="kid3NarcoticsYear"
                                [(ngModel)]="proposal.insurerConsumeNarcoticsNumberOfYear4" id="kid3NarcoticsYear"
                                #kid3NarcoticsYear="ngModel" pattern="^((?!(0))[0-9]{1,10}\d*)$" inputmode="numeric">
                            </div>
                            <div class="form-group">
                              <input type="text" name="kid3NarcoticsQuantity" id="kid3NarcoticsQuantity"
                                class="form-control" placeholder="Quantity"
                                [(ngModel)]="proposal.insurerConsumeNarcoticsQuantity4" #kid3NarcoticsQuantity="ngModel"
                                (keydown.space)="$event.preventDefault();" pattern="^((?!(0))[0-9]{1,10}\d*)$"
                                inputmode="numeric">
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-6">
                        <div class="row">
                          <div class="col">
                            <span class="title" style="display:block">Alcohol</span>
                            <input type="radio" value="No" name="kid3Alcohol"
                              [(ngModel)]="proposal.insurerConsumeAlcohol5"><span class="mr80 ml-2 mr-2">No</span>
                            <input type="radio" name="kid3Alcohol" [(ngModel)]="proposal.insurerConsumeAlcohol4"
                              value="Yes" [checked]="proposal.kid3Alcohol"><span class="ml-2">Yes</span>
                          </div>
                        </div>
                        <div class="row" *ngIf="proposal.insurerConsumeAlcohol4 === 'Yes'">
                          <div class="col mt-3">
                            <div class="form-group">
                              <input type="text" class="form-control" placeholder="Since Years" name="kid3AlcoholYear"
                                [(ngModel)]="proposal.insurerConsumeAlcoholNumberOfYear4" id="kid3AlcoholYear"
                                #kid3AlcoholYear="ngModel" pattern="^((?!(0))[0-9]{1,10}\d*)$" inputmode="numeric">
                            </div>
                            <div class="form-group">
                              <input type="text" name="kid3AlcoholYear" id="kid3AlcoholYear" class="form-control"
                                placeholder="Quantity" [(ngModel)]="proposal.insurerConsumeAlcoholQuantity4"
                                #kid3AlcoholYear="ngModel" (keydown.space)="$event.preventDefault();"
                                pattern="^((?!(0))[0-9]{1,10}\d*)$" inputmode="numeric">
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-6">
                        <div class="row">
                          <div class="col">
                            <span class="title" style="display:block">Tobacco/Guthka, etc</span>
                            <input type="radio" value="No" name="kid3Tobacco"
                              [(ngModel)]="proposal.insurerConsumeTobacco5"><span class="mr80 ml-2 mr-2">No</span>
                            <input type="radio" name="kid3Tobacco" [(ngModel)]="proposal.insurerConsumeTobacco4"
                              value="Yes" [checked]="proposal.kid3Tobacco"><span class="ml-2">Yes</span>
                          </div>
                        </div>
                        <div class="row" *ngIf="proposal.insurerConsumeTobacco4 === 'Yes'">
                          <div class="col mt-3">
                            <div class="form-group">
                              <input type="text" class="form-control" placeholder="Since Years" name="kid3TobaccoYear"
                                [(ngModel)]="proposal.insurerTobaccoNumberOfYear4" id="kid3TobaccoYear"
                                #kid3TobaccoYear="ngModel" pattern="^((?!(0))[0-9]{1,10}\d*)$" inputmode="numeric">
                            </div>
                            <div class="form-group">
                              <input type="text" name="kid3TobaccoDays" id="kid3TobaccoDays" class="form-control"
                                placeholder="No. of packs(In a day)" [(ngModel)]="proposal.insurerTobaccoQuantity4"
                                #kid3TobaccoDays="ngModel" (keydown.space)="$event.preventDefault();"
                                pattern="^((?!(0))[0-9]{1,10}\d*)$" inputmode="numeric">
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row mt-4">
                      <div class="col-12 text-center">
                        <button class="btn btn-bordered-blue" (click)="nextStep('2')">Next</button>
                      </div>
                    </div>
                  </form>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
        <form name="form" #proposalFormTabThree="ngForm">
          <div [hidden]="nomineeDetails" class="container">
            <div (click)="backtoprevTab('3')" class="left-arw"></div>
            <div class="row">
              <div class="col-2" style="padding-right:0px;">
                <p class="title mendatory">Title</p>
                <div class="sum-insured-input">
                  <div class="form-group">
                    <select class="form-control" name="nomineeTitle" [(ngModel)]="proposal.nomineeTitle"
                      id="nomineeTitle" #nomineeTitle="ngModel" required>
                      <option value="M">Mr</option>
                      <option value="F">Mrs</option>
                      <option value="F">Ms</option>
                    </select>
                    <div *ngIf="nomineeTitle.invalid && nomineeTitle.touched " class="error-message">
                      <div *ngIf="nomineeTitle.errors.required">
                        Title is required.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-5">
                <p class="title mendatory">First Name</p>
                <div class="sum-insured-input">
                  <div class="form-group">
                    <input class="form-control" type="text" name="nomineeFirstName"
                      [(ngModel)]="proposal.nomineeFirstName" id="nomineeFirstName" #nomineeFirstName="ngModel"
                      pattern="[a-zA-Z]+" maxlength="200" required>
                    <div *ngIf="nomineeFirstName.invalid && nomineeFirstName.touched " class="error-message">
                      <div *ngIf="nomineeFirstName.errors.required">
                        First Name is required.
                      </div>
                      <div *ngIf="nomineeFirstName.errors.pattern">
                        Please enter valid First name.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-5">
                <p class="title mendatory">Last Name</p>
                <div class="sum-insured-input">
                  <div class="form-group">
                    <input class="form-control" type="text" name="nomineeLastName"
                      [(ngModel)]="proposal.nomineeLastName" id="nomineeLastName" #nomineeLastName="ngModel"
                      pattern="[a-zA-Z\s]+" maxlength="200" required>
                    <div *ngIf="nomineeLastName.invalid && nomineeLastName.touched " class="error-message">
                      <div *ngIf="nomineeLastName.errors.required">
                        Last Name is required.
                      </div>
                      <div *ngIf="nomineeLastName.errors.pattern">
                        Please enter valid Last name.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <p class="title mendatory">Mobile No.</p>
                <div class="sum-insured-input">
                  <div class="form-group">
                    <input type="text" name="nomineeMobile" id="nomineeMobile" class="form-control"
                      placeholder="Mobile No." [(ngModel)]="proposal.nomineeMobile" #nomineeMobile="ngModel"
                      maxlength="10" minlength="10" (keydown.space)="$event.preventDefault();"
                      pattern="^((?!(0))[0-9]{1,10}\d*)$" inputmode="numeric" required>
                    <div *ngIf="nomineeMobile.invalid && nomineeMobile.touched " class="error-message">
                      <div *ngIf="nomineeMobile.errors.required">
                        Mobile number is required.
                      </div>
                      <div *ngIf="nomineeMobile.errors.maxlength">
                        Mobile number should not be greater than 10 digits.
                      </div>
                      <div *ngIf="nomineeMobile.errors.minlength">
                        Mobile number must be at least 10 digits long.
                      </div>
                      <div
                        *ngIf="(!nomineeMobile.errors.minlength || nomineeMobile.errors.pattern) && !nomineeMobile.errors.required">
                        Invalid mobile number.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <p class="title mendatory">DOB</p>
                <div class="sum-insured-input reg-date-input reg-date-input1">
                  <div class="input-group form-group">
                    <div class="input-group addon">
                      <img
                        src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/common-icons/Date.svg">
                      <p-calendar [touchUI]="true" [readonlyInput]="true" [(ngModel)]="proposal.nomineeDob"
                        dateFormat="dd/mm/yy" [monthNavigator]="true" [yearNavigator]="true" yearRange="1900:{{currentDate.getFullYear()}}"
                        placeholder="Date" name="nomineeDob" [maxDate]="currentDate"
                        (onSelect)="calculateAge();getGaurdianMinDobDate(proposal.nomineeDob)" keepInvalid
                        [required]="true"></p-calendar>
                      <span class="input-group-addon" id="basic-addon-dueDate"></span>
                    </div>
                  </div>
                  <div *ngIf="shouldBe18" class="error-message">
                    Date of birth should be greater than 18.
                  </div>
                  <div *ngIf="nomineeDOBrequired" class="error-message">
                    Date of Birth is required.
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <p class="title mendatory">Nominee Relationship</p>
                <div class="sum-insured-input">
                  <div class="form-group">
                    <select class="form-control long-text" id="nomineeRelation" name="nomineeRelation"
                      [(ngModel)]="proposal.nomineeRelationship1" #nomineeRelation="ngModel" required>
                      <option value="Brother">Brother</option>
                      <option value="Brother in Law">Brother in Law</option>
                      <option value="Daughter">Daughter</option>
                      <option value="Father">Father</option>
                      <option value="Grand Father">Grand Father</option>
                      <option value="Grand Mother">Grand Mother</option>
                      <option value="Husband">Husband</option>
                      <option value="Mother">Mother</option>
                      <option value="Mother in Law">Mother in Law</option>
                      <option value="Sister">Sister</option>
                      <option value="Sister in Law">Sister in Law</option>
                      <option value="Son">Son</option>
                      <option value="Wife">Wife</option>
                      <option value="Self">Self</option>
                    </select>
                    <div *ngIf="nomineeRelation.invalid && nomineeRelation.touched " class="error-message">
                      <div *ngIf="nomineeRelation.errors.required">
                        Please select Nominee Relation.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <label class="checkbox-inline"><input type="checkbox" [(ngModel)]="proposal.nomineeAddressAutoFill"
                    (click)="nomineeAddressAutoFill();"> Is Nominee's address same as proposer's
                  address.</label>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <p class="title mendatory">Residential Address</p>
                <div class="sum-insured-input">
                  <div class="form-group">
                    <textarea class="form-control" type="text" name="address1" [(ngModel)]="proposal.nomineeAddress1"
                      id="nomineeAddress" #nomineeAddress="ngModel" maxlength="500"></textarea>
                    <div *ngIf="nomineeAddress.invalid && address1.touched " class="error-message">
                      <div *ngIf="nomineeAddress.errors.required">
                        Address is required.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <p class="title mendatory">Pin Code</p>
                <div class="sum-insured-input">
                  <div class="form-group">
                    <input class="form-control" type="number" name="pinCode" [(ngModel)]="proposal.nomineePincode"
                      (keydown.space)="$event.preventDefault();" (focusout)="getCityStateList(f.pincode)" maxlength="6"
                      minlength="6" id="nomineePincode" #nomineePincode="ngModel"
                      oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                      required>
                    <div *ngIf="invalidPincode" class="error-message">
                      Invalid pincode.
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <p class="title mendatory">State</p>
                <div class="sum-insured-input">
                  <div class="form-group">
                    <select class="form-control" name="state" [(ngModel)]="proposal.nomineeState"
                      (change)="getStateCityForRoyal(2, proposal.nomineeState)">
                      <option>Select State</option>
                      <option *ngFor="let state of royalStateList" value="{{state}}">{{state}}</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <p class="title mendatory">City</p>
                <div class="sum-insured-input">
                  <select name="nomineeCity" class="form-control quote-dropdown" id="nomineeCity" name="nomineeCity"
                    [(ngModel)]="proposal.nomineeCity" #nomineeCity="ngModel" required>
                    <option *ngFor="let city of royalCityList" value="{{city}}">{{city | uppercase}}</option>
                  </select>
                  <div *ngIf="nomineeCity.invalid && nomineeCity.touched " class="error-message">
                    <div *ngIf="nomineeCity.errors.required">
                      City is required.
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div *ngIf="nomineeGaurdianDetails" class="container"><br>
              <hr>
              <p class="title">If DOB of nominee is less than 18, then guardian details are also needed</p>
              <div class="row">
                <div class="col-2" style="padding-right:0px;">
                  <p class="title mendatory">Title</p>
                  <div class="sum-insured-input">
                    <div class="form-group">
                      <select class="form-control" name="guardianTitle1" [(ngModel)]="proposal.guardianTitle"
                        id="guardianTitle1" #guardianTitle1="ngModel" required>
                        <option value="Mr">Mr</option>
                        <option value="Ms">Ms</option>
                      </select>
                      <div *ngIf="guardianTitle1.invalid && guardianTitle1.touched " class="error-message">
                        <div *ngIf="guardianTitle1.errors.required">
                          Title is required.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-5">
                  <p class="title mendatory">First Name</p>
                  <div class="sum-insured-input">
                    <div class="form-group">
                      <input class="form-control" type="text" name="guardianFirstName1"
                        [(ngModel)]="proposal.guardianFirstName" id="guardianFirstName1" #guardianFirstName1="ngModel"
                        pattern="[a-zA-Z]+" maxlength="200" required>
                      <div *ngIf="guardianFirstName1.invalid && guardianFirstName1.touched " class="error-message">
                        <div *ngIf="guardianFirstName1.errors.required">
                          Guardian's first Name is required.
                        </div>
                        <div *ngIf="guardianFirstName1.errors.pattern">
                          Please enter valid Gaurdian's first name.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-5">
                  <p class="title mendatory">Last Name</p>
                  <div class="sum-insured-input">
                    <div class="form-group">
                      <input class="form-control" type="text" name="guardianLastName1"
                        [(ngModel)]="proposal.guardianLastName" id="guardianLastName1" #guardianLastName1="ngModel"
                        pattern="[a-zA-Z\s]+" maxlength="200" required>
                      <div *ngIf="guardianLastName1.invalid && guardianLastName1.touched " class="error-message">
                        <div *ngIf="guardianLastName1.errors.required">
                          Guardian's last Name is required.
                        </div>
                        <div *ngIf="guardianLastName1.errors.pattern">
                          Please enter valid Last name.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <p class="title mendatory">Mobile No.</p>
                  <div class="sum-insured-input">
                    <div class="form-group">
                      <input type="text" name="guardianMobile1" id="guardianMobile1" class="form-control"
                        placeholder="Mobile No." [(ngModel)]="proposal.guardianMobile" #guardianMobile1="ngModel"
                        maxlength="10" minlength="10" (keydown.space)="$event.preventDefault();"
                        pattern="^((?!(0))[0-9]{1,10}\d*)$" inputmode="numeric" required>
                      <div *ngIf="guardianMobile1.invalid && guardianMobile1.touched " class="error-message">
                        <div *ngIf="guardianMobile1.errors.required">
                          Mobile number is required.
                        </div>
                        <div *ngIf="guardianMobile1.errors.maxlength">
                          Mobile number should not be greater than 10 digits.
                        </div>
                        <div *ngIf="guardianMobile1.errors.minlength">
                          Mobile number must be at least 10 digits long.
                        </div>
                        <div
                          *ngIf="(!guardianMobile1.errors.minlength || guardianMobile1.errors.pattern) && !guardianMobile1.errors.required">
                          Invalid mobile number.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <p class="title mendatory">DOB</p>
                  <div class="sum-insured-input reg-date-input reg-date-input1">
                    <div class="input-group form-group">
                      <div class="input-group addon">
                        <img
                          src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/common-icons/Date.svg">
                        <p-calendar [touchUI]="true" [readonlyInput]="true" [(ngModel)]="proposal.guardianDob"
                          dateFormat="dd/mm/yy" [monthNavigator]="true" [yearNavigator]="true"
                          yearRange="1960:{{maxYearGaurdianDate}}" placeholder="Date" name="guardianDob1"
                          [maxDate]="getGaurdianMinDate" (onSelect)="getGaurdianAge(proposal.guardianDob1);" keepInvalid
                          [required]="true"></p-calendar>
                        <span class="input-group-addon" id="basic-addon-dueDate"></span>
                      </div>
                    </div>
                    <!-- <div *ngIf="shouldBe18" class="error-message">
                    Date of birth should be greater than 18.
                  </div>
                  <div *ngIf="DOBrequired" class="error-message">
                    Date of Birth is required.
                  </div> -->
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <p class="title mendatory">Age</p>
                  <div class="sum-insured-input">
                    <div class="form-group">
                      <input class="form-control" type="text" name="guardianAge1" [(ngModel)]="proposal.guardianAge"
                        id="guardianAge1" #guardianAge1="ngModel" required>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <p class="title mendatory">Guardian Relationship</p>
                  <div class="sum-insured-input">
                    <div class="form-group">
                      <select class="form-control long-text" id="guardianRelationship1" name="guardianRelationship1"
                        [(ngModel)]="proposal.guardianRelationship1" #guardianRelationship1="ngModel" required>
                        <option value="Mother">MOTHER</option>
                        <option value="Uncle">UNCLE</option>
                        <option value="Aunt">AUNT</option>
                        <option value="Nephew">NEPHEW</option>
                        <option value="Niece">NIECE</option>
                        <option value="Sister">SISTER</option>
                        <option value="Brother">BROTHER</option>
                        <option value="Brother in Law">BROTHER IN LAW</option>
                        <option value="Sister in Law">SISTER IN LAW</option>
                        <option value="Cousin">COUSIN</option>
                      </select>
                      <div *ngIf="guardianRelationship1.invalid && guardianRelationship1.touched "
                        class="error-message">
                        <div *ngIf="guardianRelationship1.errors.required">
                          Please select Nominee Relation.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <p class="title mendatory">Residential Address</p>
                  <div class="sum-insured-input">
                    <div class="form-group">
                      <textarea class="form-control" type="text" name="guardianAddress1"
                        [(ngModel)]="proposal.guardianAddress1" id="guardianAddress1" #guardianAddress1="ngModel"
                        maxlength="500"></textarea>
                      <div *ngIf="guardianAddress1.invalid && guardianAddress1.touched " class="error-message">
                        <div *ngIf="guardianAddress1.errors.required">
                          Address is required.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <p class="title mendatory">Pin Code</p>
                  <div class="sum-insured-input">
                    <div class="form-group">
                      <input class="form-control" type="number" name="pinCode" [(ngModel)]="proposal.guardianPincode"
                        (keydown.space)="$event.preventDefault();" (keypress)="keyPress($event)"
                        (focusout)="getCityStateList(f.pincode)" maxlength="6" minlength="6" id="guardianPincode1"
                        #guardianPincode1="ngModel"
                        oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                        required>
                      <div *ngIf="invalidPincode" class="error-message">
                        Invalid pincode.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <p class="title mendatory">State</p>
                  <div class="sum-insured-input">
                    <div class="form-group">
                      <select class="form-control" name="state" [(ngModel)]="proposal.guardianState"
                        (change)="getStateCityForRoyal(2, proposal.guardianState)">
                        <option>Select State</option>
                        <option *ngFor="let state of royalStateList" value="{{state}}">{{state}}</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <p class="title mendatory">City</p>
                  <div class="sum-insured-input">
                    <select name="guardianCity1" class="form-control quote-dropdown" id="guardianCity"
                      name="guardianCity1" [(ngModel)]="proposal.guardianCity1" #guardianCity1="ngModel" required>
                      <option *ngFor="let city of royalCityList" value="{{city}}">{{city | uppercase}}</option>
                    </select>
                    <div *ngIf="guardianCity1.invalid && guardianCity1.touched " class="error-message">
                      <div *ngIf="guardianCity1.errors.required">
                        City is required.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-12 text-center">
                <button class="btn btn-bordered-blue" [disabled]="!proposalFormTabThree.valid"
                  (click)="nextStep('3')">Proceed</button>
              </div>
            </div>
          </div>
        </form>
        <form name="form" #proposalFormTabFour="ngForm">
          <div [hidden]="healthDetails" class="container">
            <div (click)="backtoprevTab('4')" class="left-arw"></div>
            <div class="row">
              <div class="col">
                <div class="title">Within the last 2 years have you consulted a doctor or healthcare professional?
                  (other
                  than Preventive Health Check-up or Pre Employment Health Check-up)</div>
                <input type="radio" name="question1" [value]="false" [(ngModel)]="proposalForm.question1"><span
                  class="mr80 ml-2 mr-4">No</span>
                <input type="radio" name="question1" [(ngModel)]="proposalForm.question1" [value]="true"
                  [checked]="proposalForm.question1"><span class="ml-2">Yes</span>
              </div>
            </div>
            <div class="row" *ngIf="proposalForm.question1">
              <div class="col mt-3">
                <div class="row">
                  <div class="col-6">
                    <p>Self</p>
                  </div>
                  <div class="col-6">
                    <input type="radio" name="selfQuestion1" value="No" [(ngModel)]="proposal.healthCheckUp1"><span
                      class="mr80 ml-2 mr-4">No</span>
                    <input type="radio" name="selfQuestion1" value="Yes" [(ngModel)]="proposal.healthCheckUp1"><span
                      class="ml-2">Yes</span>
                  </div>
                </div>
                <div class="row" *ngIf="this.membersCount >= 2">
                  <div class="col-6">
                    <p>Spouse</p>
                  </div>
                  <div class="col-6">
                    <input type="radio" name="spouseQuestion1" value="No" [(ngModel)]="proposal.healthCheckUp2"><span
                      class="mr80 ml-2 mr-4">No</span>
                    <input type="radio" name="spouseQuestion1" value="Yes" [(ngModel)]="proposal.healthCheckUp2"><span
                      class="ml-2">Yes</span>
                  </div>
                </div>
                <div class="row" *ngIf="this.membersCount >= 3">
                  <div class="col-6">
                    <p>Kid 1</p>
                  </div>
                  <div class="col-6">
                    <input type="radio" name="kid1Question1" value="No" [(ngModel)]="proposal.healthCheckUp3"><span
                      class="mr80 ml-2 mr-4">No</span>
                    <input type="radio" name="kid1Question1" value="Yes" [(ngModel)]="proposal.healthCheckUp3"><span
                      class="ml-2">Yes</span>
                  </div>
                </div>
                <div class="row" *ngIf="this.membersCount >= 4">
                  <div class="col-6">
                    <p>Kid 2</p>
                  </div>
                  <div class="col-6">
                    <input type="radio" name="kid2Question1" value="No" [(ngModel)]="proposal.healthCheckUp4"><span
                      class="mr80 ml-2 mr-4">No</span>
                    <input type="radio" name="kid2Question1" value="Yes" [(ngModel)]="proposal.healthCheckUp4"><span
                      class="ml-2">Yes</span>
                  </div>
                </div>
                <div class="row" *ngIf="this.membersCount === 5">
                  <div class="col-6">
                    <p>Kid 3</p>
                  </div>
                  <div class="col-6">
                    <input type="radio" name="kid3Question1" value="No" [(ngModel)]="proposal.healthCheckUp5"><span
                      class="mr80 ml-2 mr-4">No</span>
                    <input type="radio" name="kid3Question1" value="Yes" [(ngModel)]="proposal.healthCheckUp5"><span
                      class="ml-2">Yes</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col">
                <div class="title">Within the last 2 years have you underwent for any detailed investigation? (e.g.
                  X-ray, CT Scan, biopsy, MRI, Sonography, etc) (other than Preventive Health Check-up or Pre Employment
                  Health Check-up)</div>
                <input type="radio" name="question2" [value]="false" [(ngModel)]="proposalForm.question2"><span
                  class="mr80 ml-2 mr-4">No</span>
                <input type="radio" name="question2" [(ngModel)]="proposalForm.question2" [value]="true"
                  [checked]="proposalForm.question2"><span class="ml-2">Yes</span>
              </div>
            </div>
            <div class="row" *ngIf="proposalForm.question2">
              <div class="col mt-3">
                <div class="row">
                  <div class="col-6">
                    <p>Self</p>
                  </div>
                  <div class="col-6">
                    <input type="radio" name="selfQuestion2" value="No"
                      [(ngModel)]="proposal.healthDetailedInvestigation1"><span class="mr80 ml-2 mr-4">No</span>
                    <input type="radio" value="Yes" name="selfQuestion2"
                      [(ngModel)]="proposal.healthDetailedInvestigation1" [checked]="selfQuestion2"><span
                      class="ml-2">Yes</span>
                  </div>
                </div>
                <div class="row" *ngIf="this.membersCount >= 2">
                  <div class="col-6">
                    <p>Spouse</p>
                  </div>
                  <div class="col-6">
                    <input type="radio" name="spouseQuestion2" value="No"
                      [(ngModel)]="proposal.healthDetailedInvestigation2"><span class="mr80 ml-2 mr-4">No</span>
                    <input type="radio" value="Yes" name="spouseQuestion2"
                      [(ngModel)]="proposal.healthDetailedInvestigation2" [checked]="spouseQuestion2"><span
                      class="ml-2">Yes</span>
                  </div>
                </div>
                <div class="row" *ngIf="this.membersCount >= 3">
                  <div class="col-6">
                    <p>Kid 1</p>
                  </div>
                  <div class="col-6">
                    <input type="radio" name="kid1Question2" value="No"
                      [(ngModel)]="proposal.healthDetailedInvestigation3"><span class="mr80 ml-2 mr-4">No</span>
                    <input type="radio" value="Yes" name="kid1Question2"
                      [(ngModel)]="proposal.healthDetailedInvestigation3" [checked]="kid1Question2"><span
                      class="ml-2">Yes</span>
                  </div>
                </div>
                <div class="row" *ngIf="this.membersCount >= 4">
                  <div class="col-6">
                    <p>Kid 2</p>
                  </div>
                  <div class="col-6">
                    <input type="radio" name="kid2Question2" value="No"
                      [(ngModel)]="proposal.healthDetailedInvestigation4"><span class="mr80 ml-2 mr-4">No</span>
                    <input type="radio" value="Yes" name="kid2Question2"
                      [(ngModel)]="proposal.healthDetailedInvestigation4" [checked]="kid2Question2"><span
                      class="ml-2">Yes</span>
                  </div>
                </div>
                <div class="row" *ngIf="this.membersCount === 5">
                  <div class="col-6">
                    <p>Kid 3</p>
                  </div>
                  <div class="col-6">
                    <input type="radio" name="kid3Question2" value="No"
                      [(ngModel)]="proposal.healthDetailedInvestigation5"><span class="mr80 ml-2 mr-4">No</span>
                    <input type="radio" value="Yes" name="kid3Question2"
                      [(ngModel)]="proposal.healthDetailedInvestigation5" [checked]="kid3Question2"><span
                      class="ml-2">Yes</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col">
                <div class="title">Within the last 5 years have you been to a hospital for an operation/medical
                  treatment?</div>
                <input type="radio" name="question3" [value]="false" [(ngModel)]="proposalForm.question3"><span
                  class="mr80 ml-2 mr-4">No</span>
                <input type="radio" name="question3" [(ngModel)]="proposalForm.question3" [value]="true"
                  [checked]="proposalForm.question3"><span class="ml-2">Yes</span>
              </div>
            </div>
            <div class="row" *ngIf="proposalForm.question3">
              <div class="col mt-3">
                <div class="row">
                  <div class="col-6">
                    <p>Self</p>
                  </div>
                  <div class="col-6">
                    <input type="radio" name="selfQuestion3" value="No"
                      [(ngModel)]="proposal.hospatalizedLastFiveYears1"><span class="mr80 ml-2 mr-4">No</span>
                    <input type="radio" value="Yes" name="selfQuestion3"
                      [(ngModel)]="proposal.hospatalizedLastFiveYears1" [checked]="selfQuestion3"><span
                      class="ml-2">Yes</span>
                  </div>
                </div>
                <div class="row" *ngIf="this.membersCount >= 2">
                  <div class="col-6">
                    <p>Spouse</p>
                  </div>
                  <div class="col-6">
                    <input type="radio" name="spouseQuestion3" value="No"
                      [(ngModel)]="proposal.hospatalizedLastFiveYears2"><span class="mr80 ml-2 mr-4">No</span>
                    <input type="radio" value="Yes" name="spouseQuestion3"
                      [(ngModel)]="proposal.hospatalizedLastFiveYears2" [checked]="spouseQuestion3"><span
                      class="ml-2">Yes</span>
                  </div>
                </div>
                <div class="row" *ngIf="this.membersCount >= 3">
                  <div class="col-6">
                    <p>Kid 1</p>
                  </div>
                  <div class="col-6">
                    <input type="radio" name="kid1Question3" value="No"
                      [(ngModel)]="proposal.hospatalizedLastFiveYears3"><span class="mr80 ml-2 mr-4">No</span>
                    <input type="radio" value="Yes" name="kid1Question3"
                      [(ngModel)]="proposal.hospatalizedLastFiveYears3" [checked]="kid1Question3"><span
                      class="ml-2">Yes</span>
                  </div>
                </div>
                <div class="row" *ngIf="this.membersCount >= 4">
                  <div class="col-6">
                    <p>Kid 2</p>
                  </div>
                  <div class="col-6">
                    <input type="radio" name="kid2Question3" value="No"
                      [(ngModel)]="proposal.hospatalizedLastFiveYears4"><span class="mr80 ml-2 mr-4">No</span>
                    <input type="radio" value="Yes" name="kid2Question3"
                      [(ngModel)]="proposal.hospatalizedLastFiveYears4" [checked]="kid2Question3"><span
                      class="ml-2">Yes</span>
                  </div>
                </div>
                <div class="row" *ngIf="this.membersCount === 5">
                  <div class="col-6">
                    <p>Kid 3</p>
                  </div>
                  <div class="col-6">
                    <input type="radio" name="kid3Question3" value="No"
                      [(ngModel)]="proposal.hospatalizedLastFiveYears5"><span class="mr80 ml-2 mr-4">No</span>
                    <input type="radio" value="Yes" name="kid3Question3"
                      [(ngModel)]="proposal.hospatalizedLastFiveYears5" [checked]="kid3Question3"><span
                      class="ml-2">Yes</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col">
                <div class="title">Do you take tablets, medicines or drugs on a regular basis?</div>
                <input type="radio" name="question4" [value]="false" [(ngModel)]="proposalForm.question4"><span
                  class="mr80 ml-2 mr-4">No</span>
                <input type="radio" name="question4" [(ngModel)]="proposalForm.question4" [value]="true"
                  [checked]="proposalForm.question4"><span class="ml-2">Yes</span>
              </div>
            </div>
            <div class="row" *ngIf="proposalForm.question4">
              <div class="col mt-3">
                <div class="row">
                  <div class="col-6">
                    <p>Self</p>
                  </div>
                  <div class="col-6">
                    <input type="radio" name="selfQuestion4" value="No"
                      [(ngModel)]="proposal.insurarTakeMedicineOnRegularBasis1"><span class="mr80 ml-2 mr-4">No</span>
                    <input type="radio" value="Yes" name="selfQuestion4"
                      [(ngModel)]="proposal.insurarTakeMedicineOnRegularBasis1" [checked]="selfQuestion4"><span
                      class="ml-2">Yes</span>
                  </div>
                </div>
                <div class="row" *ngIf="this.membersCount >= 2">
                  <div class="col-6">
                    <p>Spouse</p>
                  </div>
                  <div class="col-6">
                    <input type="radio" name="spouseQuestion4" value="No"
                      [(ngModel)]="proposal.insurarTakeMedicineOnRegularBasis2"><span class="mr80 ml-2 mr-4">No</span>
                    <input type="radio" value="Yes" name="spouseQuestion4"
                      [(ngModel)]="proposal.insurarTakeMedicineOnRegularBasis2" [checked]="spouseQuestion4"><span
                      class="ml-2">Yes</span>
                  </div>
                </div>
                <div class="row" *ngIf="this.membersCount >= 3">
                  <div class="col-6">
                    <p>Kid 1</p>
                  </div>
                  <div class="col-6">
                    <input type="radio" name="kid1Question4" value="No"
                      [(ngModel)]="proposal.insurarTakeMedicineOnRegularBasis3"><span class="mr80 ml-2 mr-4">No</span>
                    <input type="radio" value="Yes" name="kid1Question4"
                      [(ngModel)]="proposal.insurarTakeMedicineOnRegularBasis3" [checked]="kid1Question4"><span
                      class="ml-2">Yes</span>
                  </div>
                </div>
                <div class="row" *ngIf="this.membersCount >= 4">
                  <div class="col-6">
                    <p>Kid 2</p>
                  </div>
                  <div class="col-6">
                    <input type="radio" name="kid2Question4" value="No"
                      [(ngModel)]="proposal.insurarTakeMedicineOnRegularBasis4"><span class="mr80 ml-2 mr-4">No</span>
                    <input type="radio" value="Yes" name="kid2Question4"
                      [(ngModel)]="proposal.insurarTakeMedicineOnRegularBasis4" [checked]="kid2Question4"><span
                      class="ml-2">Yes</span>
                  </div>
                </div>
                <div class="row" *ngIf="this.membersCount === 5">
                  <div class="col-6">
                    <p>Kid 3</p>
                  </div>
                  <div class="col-6">
                    <input type="radio" name="kid3Question4" value="No"
                      [(ngModel)]="proposal.insurarTakeMedicineOnRegularBasis5"><span class="mr80 ml-2 mr-4">No</span>
                    <input type="radio" value="Yes" name="kid3Question4"
                      [(ngModel)]="proposal.insurarTakeMedicineOnRegularBasis5" [checked]="kid3Question4"><span
                      class="ml-2">Yes</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col">
                <div class="title">Within the last 3 months have you experienced any health problems or medical
                  conditions which you/proposed insured person have/has not seen a doctor for?</div>
                <input type="radio" name="question5" [value]="false" [(ngModel)]="proposalForm.question5"><span
                  class="mr80 ml-2 mr-4">No</span>
                <input type="radio" name="question5" [(ngModel)]="proposalForm.question5" [value]="true"
                  [checked]="proposalForm.question5"><span class="ml-2">Yes</span>
              </div>
            </div>
            <div class="row" *ngIf="proposalForm.question5">
              <div class="col mt-3">
                <div class="row">
                  <div class="col-6">
                    <p>Self</p>
                  </div>
                  <div class="col-6">
                    <input type="radio" name="selfQuestion5" value="No"
                      [(ngModel)]="proposal.insurerHealthProblemInLastThreeMonth1"><span
                      class="mr80 ml-2 mr-4">No</span>
                    <input type="radio" name="selfQuestion5" value="Yes"
                      [(ngModel)]="proposal.insurerHealthProblemInLastThreeMonth1" [checked]="selfQuestion5"><span
                      class="ml-2">Yes</span>
                  </div>
                </div>
                <div class="row" *ngIf="this.membersCount >= 2">
                  <div class="col-6">
                    <p>Spouse</p>
                  </div>
                  <div class="col-6">
                    <input type="radio" name="spouseQuestion5" value="No"
                      [(ngModel)]="proposal.insurerHealthProblemInLastThreeMonth2"><span
                      class="mr80 ml-2 mr-4">No</span>
                    <input type="radio" name="spouseQuestion5" value="Yes"
                      [(ngModel)]="proposal.insurerHealthProblemInLastThreeMonth2" [checked]="spouseQuestion5"><span
                      class="ml-2">Yes</span>
                  </div>
                </div>
                <div class="row" *ngIf="this.membersCount >= 3">
                  <div class="col-6">
                    <p>Kid 1</p>
                  </div>
                  <div class="col-6">
                    <input type="radio" name="kid1Question5" value="No"
                      [(ngModel)]="proposal.insurerHealthProblemInLastThreeMonth3"><span
                      class="mr80 ml-2 mr-4">No</span>
                    <input type="radio" name="kid1Question5" value="Yes"
                      [(ngModel)]="proposal.insurerHealthProblemInLastThreeMonth3" [checked]="kid1Question5"><span
                      class="ml-2">Yes</span>
                  </div>
                </div>
                <div class="row" *ngIf="this.membersCount >= 4">
                  <div class="col-6">
                    <p>Kid 2</p>
                  </div>
                  <div class="col-6">
                    <input type="radio" name="kid2Question5" value="No"
                      [(ngModel)]="proposal.insurerHealthProblemInLastThreeMonth4"><span
                      class="mr80 ml-2 mr-4">No</span>
                    <input type="radio" name="kid2Question5" value="Yes"
                      [(ngModel)]="proposal.insurerHealthProblemInLastThreeMonth4" [checked]="kid2Question5"><span
                      class="ml-2">Yes</span>
                  </div>
                </div>
                <div class="row" *ngIf="this.membersCount === 5">
                  <div class="col-6">
                    <p>Kid 3</p>
                  </div>
                  <div class="col-6">
                    <input type="radio" name="kid3Question5" value="No"
                      [(ngModel)]="proposal.insurerHealthProblemInLastThreeMonth5"><span
                      class="mr80 ml-2 mr-4">No</span>
                    <input type="radio" name="kid3Question5" value="Yes"
                      [(ngModel)]="proposal.insurerHealthProblemInLastThreeMonth5" [checked]="kid3Question5"><span
                      class="ml-2">Yes</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col">
                <div class="title">Have any of the person proposed to be insured ever suffered from or taken treatment,
                  or hospitalized for or have been recommended to take investigations/ medication/surgery or undergone a
                  surgery for any of the following- Diabetes; Hypertension; Ulcer/Cyst/Cancer; Cardiac Disorder; Kidney
                  or
                  Urinary Tract Disorder; Disorder of muscle/bone/joint; Respiratory disorder; Digestive tract or
                  gastrointestinal disorder; Nervous System disorder; Mental Illness or disorder, HIV or AIDS?</div>
                <input type="radio" name="question6" [value]="false" [(ngModel)]="proposalForm.question6"><span
                  class="mr80 ml-2 mr-4">No</span>
                <input type="radio" name="question6" [(ngModel)]="proposalForm.question6" [value]="true"
                  [checked]="proposalForm.question6"><span class="ml-2">Yes</span>
              </div>
            </div>
            <div class="row" *ngIf="proposalForm.question6">
              <div class="col mt-3">
                <div class="row">
                  <div class="col-6">
                    <p>Self</p>
                  </div>
                  <div class="col-6">
                    <input type="radio" name="selfQuestion6" value="No"
                      [(ngModel)]="proposal.insuredPersonTakenTreatmentOrHospitalized1"><span
                      class="mr80 ml-2 mr-4">No</span>
                    <input type="radio" name="selfQuestion6" value="Yes"
                      [(ngModel)]="proposal.insuredPersonTakenTreatmentOrHospitalized1" [checked]="selfQuestion6"><span
                      class="ml-2">Yes</span>
                  </div>
                </div>
                <div class="row" *ngIf="this.membersCount >= 2">
                  <div class="col-6">
                    <p>Spouse</p>
                  </div>
                  <div class="col-6">
                    <input type="radio" name="spouseQuestion6" value="No"
                      [(ngModel)]="proposal.insuredPersonTakenTreatmentOrHospitalized2"><span
                      class="mr80 ml-2 mr-4">No</span>
                    <input type="radio" name="spouseQuestion6" value="Yes"
                      [(ngModel)]="proposal.insuredPersonTakenTreatmentOrHospitalized2"
                      [checked]="spouseQuestion6"><span class="ml-2">Yes</span>
                  </div>
                </div>
                <div class="row" *ngIf="this.membersCount >= 3">
                  <div class="col-6">
                    <p>Kid 1</p>
                  </div>
                  <div class="col-6">
                    <input type="radio" name="kid1Question6" value="No"
                      [(ngModel)]="proposal.insuredPersonTakenTreatmentOrHospitalized3"><span
                      class="mr80 ml-2 mr-4">No</span>
                    <input type="radio" name="kid1Question6" value="Yes"
                      [(ngModel)]="proposal.insuredPersonTakenTreatmentOrHospitalized3" [checked]="kid1Question6"><span
                      class="ml-2">Yes</span>
                  </div>
                </div>
                <div class="row" *ngIf="this.membersCount >= 4">
                  <div class="col-6">
                    <p>Kid 2</p>
                  </div>
                  <div class="col-6">
                    <input type="radio" name="kid2Question6" value="No"
                      [(ngModel)]="proposal.insuredPersonTakenTreatmentOrHospitalized4"><span
                      class="mr80 ml-2 mr-4">No</span>
                    <input type="radio" name="kid2Question6" value="Yes"
                      [(ngModel)]="proposal.insuredPersonTakenTreatmentOrHospitalized4" [checked]="kid2Question6"><span
                      class="ml-2">Yes</span>
                  </div>
                </div>
                <div class="row" *ngIf="this.membersCount === 5">
                  <div class="col-6">
                    <p>Kid 3</p>
                  </div>
                  <div class="col-6">
                    <input type="radio" name="kid3Question6" value="No"
                      [(ngModel)]="proposal.insuredPersonTakenTreatmentOrHospitalized5"><span
                      class="mr80 ml-2 mr-4">No</span>
                    <input type="radio" name="kid3Question6" value="Yes"
                      [(ngModel)]="proposal.insuredPersonTakenTreatmentOrHospitalized5" [checked]="kid3Question6"><span
                      class="ml-2">Yes</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col">
                <div class="title">Have you ever been hospitalized in the last 3 years? Or, have been prescribed
                  hospitalization or surgery in the next 2 years?</div>
                <input type="radio" name="question7" [value]="false" [(ngModel)]="proposalForm.question7"><span
                  class="mr80 ml-2 mr-4">No</span>
                <input type="radio" name="question7" [(ngModel)]="proposalForm.question7" [value]="true"
                  [checked]="proposalForm.question7"><span class="ml-2">Yes</span>
              </div>
            </div>
            <div class="row" *ngIf="proposalForm.question7">
              <div class="col mt-3">
                <div class="row">
                  <div class="col-6">
                    <p>Self</p>
                  </div>
                  <div class="col-6">
                    <input type="text" class="form-control" placeholder="Specify Reason" name="selfQuestion7"
                      [(ngModel)]="proposal.hospatalizedLastThreeYears1">
                  </div>
                </div>
                <div class="row" *ngIf="this.membersCount >= 2">
                  <div class="col-6">
                    <p>Spouse</p>
                  </div>
                  <div class="col-6">
                    <input type="text" class="form-control" placeholder="Specify Reason" name="selfQuestion7"
                      [(ngModel)]="proposal.hospatalizedLastThreeYears2">
                  </div>
                </div>
                <div class="row" *ngIf="this.membersCount >= 3">
                  <div class="col-6">
                    <p>Kid 1</p>
                  </div>
                  <div class="col-6">
                    <input type="text" class="form-control" placeholder="Specify Reason" name="kid1Question7"
                      [(ngModel)]="proposal.hospatalizedLastThreeYears3">
                  </div>
                </div>
                <div class="row" *ngIf="this.membersCount >= 4">
                  <div class="col-6">
                    <p>Kid 2</p>
                  </div>
                  <div class="col-6">
                    <input type="text" class="form-control" placeholder="Specify Reason" name="kid2Question7"
                      [(ngModel)]="proposal.hospatalizedLastThreeYears4">
                  </div>
                </div>
                <div class="row" *ngIf="this.membersCount === 5">
                  <div class="col-6">
                    <p>Kid 3</p>
                  </div>
                  <div class="col-6">
                    <input type="text" class="form-control" placeholder="Specify Reason" name="kid3Question7"
                      [(ngModel)]="proposal.hospatalizedLastThreeYears5">
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col">
                <div class="title">Are you currently taking any prescribed medication?</div>
                <input type="radio" name="question8" [value]="false" [(ngModel)]="proposalForm.question8"><span
                  class="mr80 ml-2 mr-4">No</span>
                <input type="radio" name="question8" [(ngModel)]="proposalForm.question8" [value]="true"
                  [checked]="proposalForm.question8"><span class="ml-2">Yes</span>
              </div>
            </div>
            <div class="row" *ngIf="proposalForm.question8">
              <div class="col mt-3">
                <div class="row">
                  <div class="col-6">
                    <p>Self</p>
                  </div>
                  <div class="col-6">
                    <input type="text" class="form-control" placeholder="Specify Reason" name="selfQuestion8"
                      [(ngModel)]="proposal.insurerTakingPrescribedMedication1">
                  </div>
                </div>
                <div class="row" *ngIf="this.membersCount >= 2">
                  <div class="col-6">
                    <p>Spouse</p>
                  </div>
                  <div class="col-6">
                    <input type="text" class="form-control" placeholder="Specify Reason" name="spouseQuestion8"
                      [(ngModel)]="proposal.insurerTakingPrescribedMedication2">
                  </div>
                </div>
                <div class="row" *ngIf="this.membersCount >= 3">
                  <div class="col-6">
                    <p>Kid 1</p>
                  </div>
                  <div class="col-6">
                    <input type="text" class="form-control" placeholder="Specify Reason" name="kid1Question8"
                      [(ngModel)]="proposal.insurerTakingPrescribedMedication3">
                  </div>
                </div>
                <div class="row" *ngIf="this.membersCount >= 4">
                  <div class="col-6">
                    <p>Kid 2</p>
                  </div>
                  <div class="col-6">
                    <input type="text" class="form-control" placeholder="Specify Reason" name="kid2Question8"
                      [(ngModel)]="proposal.insurerTakingPrescribedMedication4">
                  </div>
                </div>
                <div class="row" *ngIf="this.membersCount === 5">
                  <div class="col-6">
                    <p>Kid 3</p>
                  </div>
                  <div class="col-6">
                    <input type="text" class="form-control" placeholder="Specify Reason" name="kid3Question8"
                      [(ngModel)]="proposal.insurerTakingPrescribedMedication5">
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col">
                <div class="title">Has your proposal for health insurance ever been declined or withdrawn by insurance
                  company?</div>
                <input type="radio" name="question9" [value]="false" [(ngModel)]="proposalForm.question9"><span
                  class="mr80 ml-2 mr-4">No</span>
                <input type="radio" name="question9" [(ngModel)]="proposalForm.question9" [value]="true"
                  [checked]="proposalForm.question9"><span class="ml-2">Yes</span>
              </div>
            </div>
            <div class="row" *ngIf="proposalForm.question9">
              <div class="col mt-3">
                <div class="row">
                  <div class="col-6">
                    <p>Self</p>
                  </div>
                  <div class="col-6">
                    <input type="text" class="form-control" placeholder="Specify Reason" name="selfQuestion9"
                      [(ngModel)]="proposal.proposalDeclinedOrWithdrawn1">
                  </div>
                </div>
                <div class="row" *ngIf="this.membersCount >= 2">
                  <div class="col-6">
                    <p>Spouse</p>
                  </div>
                  <div class="col-6">
                    <input type="text" class="form-control" placeholder="Specify Reason" name="spouseQuestion9"
                      [(ngModel)]="proposal.proposalDeclinedOrWithdrawn2">
                  </div>
                </div>
                <div class="row" *ngIf="this.membersCount >= 3">
                  <div class="col-6">
                    <p>Kid 1</p>
                  </div>
                  <div class="col-6">
                    <input type="text" class="form-control" placeholder="Specify Reason" name="kid1Question9"
                      [(ngModel)]="proposal.proposalDeclinedOrWithdrawn3">
                  </div>
                </div>
                <div class="row" *ngIf="this.membersCount >= 4">
                  <div class="col-6">
                    <p>Kid 2</p>
                  </div>
                  <div class="col-6">
                    <input type="text" class="form-control" placeholder="Specify Reason" name="kid2Question9"
                      [(ngModel)]="proposal.proposalDeclinedOrWithdrawn4">
                  </div>
                </div>
                <div class="row" *ngIf="this.membersCount === 5">
                  <div class="col-6">
                    <p>Kid 3</p>
                  </div>
                  <div class="col-6">
                    <input type="text" class="form-control" placeholder="Specify Reason" name="kid3Question9"
                      [(ngModel)]="proposal.proposalDeclinedOrWithdrawn5">
                  </div>
                </div>
              </div>
            </div>
            <div class="add-questns">
              <h4>Additional Medical Questions</h4>
              <!-- for self -->
              <div class="add-self" *ngIf="(proposal.healthCheckUp1 === 'Yes' || proposal.healthDetailedInvestigation1 === 'Yes' || proposal.hospatalizedLastFiveYears1 === 'Yes'
            || proposal.insurarTakeMedicineOnRegularBasis1 === 'Yes' || proposal.insurerHealthProblemInLastThreeMonth1 === 'Yes' 
            || proposal.insuredPersonTakenTreatmentOrHospitalized1 === 'Yes')">
                <h5>Self</h5>
                <div class="form-group row">
                  <div class="col-12">
                    <p class="title">Name of illness/Injury suffering from or suffered in the past?</p>
                  </div>
                  <div class="col-12">
                    <input type="text" class="form-control" name="injuryName1" [(ngModel)]="proposal.injuryName1"
                      required>
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-12">
                    <p class="title">Date of First Diagnosis?</p>
                  </div>
                  <div class="col-6">
                    <select class="form-control" name="diagnosisMonth1" [(ngModel)]="proposal.diagnosisMonth1" required>
                      <option selected value="">Month</option>
                      <option value="01">January</option>
                      <option value="02">February</option>
                      <option value="03">March</option>
                      <option value="04">April</option>
                      <option value="05">May</option>
                      <option value="06">June</option>
                      <option value="07">July</option>
                      <option value="08">August</option>
                      <option value="09">September</option>
                      <option value="10">October</option>
                      <option value="11">November</option>
                      <option value="12">December</option>
                    </select>
                  </div>
                  <div class="col-6">
                    <select class="form-control" name="diagnosisYear1" [(ngModel)]="proposal.diagnosisYear1" required>
                      <option *ngFor="let year of diagYears" value="{{year}}">{{year}}</option>
                    </select>
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-12">
                    <p class="title">Treatment/Medication?</p>
                  </div>
                  <div class="col-12">
                    <input type="radio" name="insurertreatmentStatus1" value="Received"
                      [(ngModel)]="proposal.insurertreatmentStatus1"><span class="mr80 ml-2 mr-4">Received</span>
                    <input type="radio" name="insurertreatmentStatus1" value="Receiving"
                      [(ngModel)]="proposal.insurertreatmentStatus1"><span class="ml-2">Receiving</span>
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-12">
                    <p class="title">Treatment Outcome?</p>
                  </div>
                  <div class="col-12">
                    <select class="form-control" name="treatmentOutcome1" [(ngModel)]="proposal.treatmentOutcome1"
                      required>
                      <option selected value="">Select</option>
                      <option value="fully cured">Fully cured</option>
                      <option value="partially cured">Partially cured</option>
                      <option value="ongoing">Ongoing</option>
                    </select>
                  </div>
                </div>
              </div>
              <!-- for self end-->
              <!--for spouse-->
              <div class="add-self" *ngIf="this.membersCount >= 2 && 
              (proposal.healthCheckUp2 === 'Yes' || proposal.healthDetailedInvestigation2 === 'Yes' || proposal.hospatalizedLastFiveYears2 === 'Yes'
              || proposal.insurarTakeMedicineOnRegularBasis2 === 'Yes' || proposal.insurerHealthProblemInLastThreeMonth2 === 'Yes' 
              || proposal.insuredPersonTakenTreatmentOrHospitalized2 === 'Yes')">
                <h5>Spouse</h5>
                <div class="form-group row">
                  <div class="col-12">
                    <p class="title">Name of illness/Injury suffering from or suffered in the past?</p>
                  </div>
                  <div class="col-12">
                    <input type="text" class="form-control" name="injuryName2" [(ngModel)]="proposal.injuryName2"
                      required>
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-12">
                    <p class="title">Date of First Diagnosis?</p>
                  </div>
                  <div class="col-6">
                    <select class="form-control" name="diagnosisMonth2" [(ngModel)]="proposal.diagnosisMonth2" required>
                      <option selected value="">Month</option>
                      <option value="01">January</option>
                      <option value="02">February</option>
                      <option value="03">March</option>
                      <option value="04">April</option>
                      <option value="05">May</option>
                      <option value="06">June</option>
                      <option value="07">July</option>
                      <option value="08">August</option>
                      <option value="09">September</option>
                      <option value="10">October</option>
                      <option value="11">November</option>
                      <option value="12">December</option>
                    </select>
                  </div>
                  <div class="col-6">
                    <select class="form-control" name="diagnosisYear2" [(ngModel)]="proposal.diagnosisYear2" required>
                      <option *ngFor="let year of diagYears" value="{{year}}">{{year}}</option>
                    </select>
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-12">
                    <p class="title">Treatment/Medication?</p>
                  </div>
                  <div class="col-12">
                    <input type="radio" name="insurertreatmentStatus2" value="Received"
                      [(ngModel)]="proposal.insurertreatmentStatus2"><span class="mr80 ml-2 mr-4">Received</span>
                    <input type="radio" name="insurertreatmentStatus2" value="Receiving"
                      [(ngModel)]="proposal.insurertreatmentStatus2"><span class="ml-2">Receiving</span>
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-12">
                    <p class="title">Treatment Outcome?</p>
                  </div>
                  <div class="col-12">
                    <select class="form-control" name="treatmentOutcome2" [(ngModel)]="proposal.treatmentOutcome2"
                      required>
                      <option selected value="">Select</option>
                      <option value="fully cured">Fully cured</option>
                      <option value="partially cured">Partially cured</option>
                      <option value="ongoing">Ongoing</option>
                    </select>
                  </div>
                </div>
              </div>
              <!--spouse end-->
              <!--for kid1-->
              <div class="add-self" *ngIf="this.membersCount >= 3 && 
                (proposal.healthCheckUp3 === 'Yes' || proposal.healthDetailedInvestigation3 === 'Yes' || proposal.hospatalizedLastFiveYears3 === 'Yes'
                || proposal.insurarTakeMedicineOnRegularBasis3 === 'Yes' || proposal.insurerHealthProblemInLastThreeMonth3 === 'Yes' 
                || proposal.insuredPersonTakenTreatmentOrHospitalized3 === 'Yes')">
                <h5>Kid1</h5>
                <div class="form-group row">
                  <div class="col-12">
                    <p class="title">Name of illness/Injury suffering from or suffered in the past?</p>
                  </div>
                  <div class="col-12">
                    <input type="text" class="form-control" name="injuryName3" [(ngModel)]="proposal.injuryName3"
                      required>
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-12">
                    <p class="title">Date of First Diagnosis?</p>
                  </div>
                  <div class="col-6">
                    <select class="form-control" name="diagnosisMonth3" [(ngModel)]="proposal.diagnosisMonth3" required>
                      <option selected value="">Month</option>
                      <option value="01">January</option>
                      <option value="02">February</option>
                      <option value="03">March</option>
                      <option value="04">April</option>
                      <option value="05">May</option>
                      <option value="06">June</option>
                      <option value="07">July</option>
                      <option value="08">August</option>
                      <option value="09">September</option>
                      <option value="10">October</option>
                      <option value="11">November</option>
                      <option value="12">December</option>
                    </select>
                  </div>
                  <div class="col-6">
                    <select class="form-control" name="diagnosisYear3" [(ngModel)]="proposal.diagnosisYear3" required>
                      <option *ngFor="let year of diagYears" value="{{year}}">{{year}}</option>
                    </select>
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-12">
                    <p class="title">Treatment/Medication?</p>
                  </div>
                  <div class="col-12">
                    <input type="radio" name="insurertreatmentStatus3" value="Received"
                      [(ngModel)]="proposal.insurertreatmentStatus3"><span class="mr80 ml-2 mr-4">Received</span>
                    <input type="radio" name="insurertreatmentStatus3" value="Receiving"
                      [(ngModel)]="proposal.insurertreatmentStatus3"><span class="ml-2">Receiving</span>
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-12">
                    <p class="title">Treatment Outcome?</p>
                  </div>
                  <div class="col-12">
                    <select class="form-control" name="treatmentOutcome3" [(ngModel)]="proposal.treatmentOutcome3"
                      required>
                      <option selected value="">Select</option>
                      <option value="fully cured">Fully cured</option>
                      <option value="partially cured">Partially cured</option>
                      <option value="ongoing">Ongoing</option>
                    </select>
                  </div>
                </div>
              </div>
              <!--kid1 end-->
              <!--for kid2-->
              <div class="add-self" *ngIf="this.membersCount >= 4 &&
                (proposal.healthCheckUp4 === 'Yes' || proposal.healthDetailedInvestigation4 === 'Yes' || proposal.hospatalizedLastFiveYears4 === 'Yes'
                || proposal.insurarTakeMedicineOnRegularBasis4 === 'Yes' || proposal.insurerHealthProblemInLastThreeMonth4 === 'Yes' 
                || proposal.insuredPersonTakenTreatmentOrHospitalized4 === 'Yes')">
                <h5>Kid2</h5>
                <div class="form-group row">
                  <div class="col-12">
                    <p class="title">Name of illness/Injury suffering from or suffered in the past?</p>
                  </div>
                  <div class="col-12">
                    <input type="text" class="form-control" name="injuryName4" [(ngModel)]="proposal.injuryName4"
                      required>
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-12">
                    <p class="title">Date of First Diagnosis?</p>
                  </div>
                  <div class="col-6">
                    <select class="form-control" name="diagnosisMonth4" [(ngModel)]="proposal.diagnosisMonth4" required>
                      <option selected value="">Month</option>
                      <option value="01">January</option>
                      <option value="02">February</option>
                      <option value="03">March</option>
                      <option value="04">April</option>
                      <option value="05">May</option>
                      <option value="06">June</option>
                      <option value="07">July</option>
                      <option value="08">August</option>
                      <option value="09">September</option>
                      <option value="10">October</option>
                      <option value="11">November</option>
                      <option value="12">December</option>
                    </select>
                  </div>
                  <div class="col-6">
                    <select class="form-control" name="diagnosisYear4" [(ngModel)]="proposal.diagnosisYear4" required>
                      <option *ngFor="let year of diagYears" value="{{year}}">{{year}}</option>
                    </select>
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-12">
                    <p class="title">Treatment/Medication?</p>
                  </div>
                  <div class="col-12">
                    <input type="radio" name="insurertreatmentStatus4" value="Received"
                      [(ngModel)]="proposal.insurertreatmentStatus4"><span class="mr80 ml-2 mr-4">Received</span>
                    <input type="radio" name="insurertreatmentStatus4" value="Receiving"
                      [(ngModel)]="proposal.insurertreatmentStatus4"><span class="ml-2">Receiving</span>
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-12">
                    <p class="title">Treatment Outcome?</p>
                  </div>
                  <div class="col-12">
                    <select class="form-control" name="treatmentOutcome4" [(ngModel)]="proposal.treatmentOutcome4"
                      required>
                      <option selected value="">Select</option>
                      <option value="fully cured">Fully cured</option>
                      <option value="partially cured">Partially cured</option>
                      <option value="ongoing">Ongoing</option>
                    </select>
                  </div>
                </div>
              </div>
              <!--kid2 end-->
              <!--for kid3-->
              <div class="add-self" *ngIf="this.membersCount >= 5 && 
                (proposal.healthCheckUp5 === 'Yes' || proposal.healthDetailedInvestigation5 === 'Yes' || proposal.hospatalizedLastFiveYears5 === 'Yes'
                || proposal.insurarTakeMedicineOnRegularBasis5 === 'Yes' || proposal.insurerHealthProblemInLastThreeMonth5 === 'Yes' 
                || proposal.insuredPersonTakenTreatmentOrHospitalized5 === 'Yes')">
                <h5>Kid3</h5>
                <div class="form-group row">
                  <div class="col-12">
                    <p class="title">Name of illness/Injury suffering from or suffered in the past?</p>
                  </div>
                  <div class="col-12">
                    <input type="text" class="form-control" name="injuryName5" required
                      [(ngModel)]="proposal.injuryName5">
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-12">
                    <p class="title">Date of First Diagnosis?</p>
                  </div>
                  <div class="col-6">
                    <select class="form-control" name="diagnosisMonth5" required [(ngModel)]="proposal.diagnosisMonth5">
                      <option selected value="">Month</option>
                      <option value="01">January</option>
                      <option value="02">February</option>
                      <option value="03">March</option>
                      <option value="04">April</option>
                      <option value="05">May</option>
                      <option value="06">June</option>
                      <option value="07">July</option>
                      <option value="08">August</option>
                      <option value="09">September</option>
                      <option value="10">October</option>
                      <option value="11">November</option>
                      <option value="12">December</option>
                    </select>
                  </div>
                  <div class="col-6">
                    <select class="form-control" name="diagnosisYear5" required [(ngModel)]="proposal.diagnosisYear5">
                      <option *ngFor="let year of diagYears" value="{{year}}">{{year}}</option>
                    </select>
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-12">
                    <p class="title">Treatment/Medication?</p>
                  </div>
                  <div class="col-12">
                    <input type="radio" name="insurertreatmentStatus5" value="Received"
                      [(ngModel)]="proposal.insurertreatmentStatus5"><span class="mr80 ml-2 mr-4">Received</span>
                    <input type="radio" name="insurertreatmentStatus5" value="Receiving"
                      [(ngModel)]="proposal.insurertreatmentStatus5"><span class="ml-2">Receiving</span>
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-12">
                    <p class="title">Treatment Outcome?</p>
                  </div>
                  <div class="col-12">
                    <select class="form-control" name="treatmentOutcome5" [(ngModel)]="proposal.treatmentOutcome5"
                      required>
                      <option selected value="">Select</option>
                      <option value="fully cured">Fully cured</option>
                      <option value="partially cured">Partially cured</option>
                      <option value="ongoing">Ongoing</option>
                    </select>
                  </div>
                </div>
              </div>
              <!--kid3 end-->
            </div>
            <div class="row mt-4 signatory-section">
              <div class="col-6">
                <p class="title">Date</p>
                <div class="sum-insured-input">
                  <div class="form-group">
                    <input class="form-control" type="text" name="dateSignatory"
                      [(ngModel)]="proposal.authorizedSignatoryDate" id="dateSignatory" #dateSignatory="ngModel"
                      disabled required>
                    <div *ngIf="dateSignatory.invalid && dateSignatory.touched " class="error-message">
                      <div *ngIf="dateSignatory.errors.required">
                        Date is required.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-6">
                <p class="title">Name of Policy Holder</p>
                <div class="sum-insured-input">
                  <div class="form-group">
                    <input class="form-control" type="text" name="authorizedSignatory"
                      [(ngModel)]="proposal.authorizedSignatory" id="authorizedSignatory" #authorizedSignatory="ngModel"
                      required>
                    <div *ngIf="authorizedSignatory.invalid && authorizedSignatory.touched " class="error-message">
                      <div *ngIf="authorizedSignatory.errors.required">
                        Policy holder name is required.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="error-message text-center">{{errorMsg}}</div>
            <div class="row mt-5">
              <div class="col-6 text-right">
                <button class="btn btn-bordered-blue" [disabled]="!proposalFormTabFour.valid"
                  (click)="saveOrSubmitProposalPage();">Save</button>
              </div>
              <div class="col-6">
                <button type="button" class="btn btn-bordered-blue" [disabled]="!proposalFormTabFour.valid"
                  (click)="openModal(templateTandC);">Proceed</button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
  <div id="spinner" [hidden]="!loading">
    <div class="spinnerfull">
      <i class="fa fa-spinner fa-spin fa-3x"></i>
    </div>
  </div>
  <section class="intimate-successfull" *ngIf="healthThankYou">
    <div class="container">
      <div class="col text-center">
        <h2 class="done-heading">Successfully Done</h2>
        <img
          src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/common-icons/done-intimate.jpg">
      </div>
      <center class="sub-title mt-2">
        <p>THANK YOU</p>
      </center>
      <!-- <div class="col note text-center">
              <p>We have recieved your intimation requests for policy no. <span class="policyNo">KKL27889</span>.You'll recieve an email from us for further processes, regarding claim form and required document submission.</p>
          </div> -->
      <div class="col footer-strip text-center">
        <p>For any queries, please reach us at:</p>
        <img src="https://pamstaging2.securenow.in/static/images/securenow_logo.svg"
          class="img-responsive" width="40%" alt="Securenow">
        <p class="call mt-3"><span>+91 9696683999</span><span class="bar"></span><span>support@securenow.in</span></p>
      </div>
    </div>
  </section>
  <ng-template #template>

    <div class="modal-body" id="myModal">
      <div class="col">
        <h4 class="modal-title">Contact Info</h4>
      </div>
      <div class="col sum-container">
        <p class="title mt-4">Name</p>
        <div class="sum-insured-input">
          <div class="form-group">
            <input class="form-control" type="text">
          </div>
        </div>
      </div>
      <div class="col sum-container">
        <p class="title mt-4">Mobile No.</p>
        <div class="sum-insured-input">
          <div class="form-group">
            <input class="form-control" type="number" maxlength="10">
          </div>
        </div>
      </div>
      <div class="col sum-container">
        <p class="title mt-4">City</p>
        <div class="sum-insured-input">
          <div class="form-group">
            <input class="form-control" type="text">
          </div>
        </div>
      </div>
      <div class="col sum-container">
        <p class="title mt-4">E-mail Address</p>
        <div class="sum-insured-input">
          <div class="form-group">
            <input class="form-control" type="text">
          </div>
        </div>
      </div>
      <div class="col sum-container">
        <p class="title mt-4">Coupon Code</p>
        <div class="sum-insured-input">
          <div class="form-group">
            <input class="form-control" type="text">
          </div>
        </div>
      </div>
      <div class="col text-center mt-4">
        <button class="btn btn-bordered-blue" aria-label="Close" routerLink="/personal-accident-proposal"
          [disabled]="personalForm.form.invalid" (click)="modalRef.hide()">Next</button>
      </div>
    </div>
  </ng-template>
  <ng-template #templateTandC>
    <form name="form" (ngSubmit)="f.form.valid" #f="ngForm">
      <div class="modal-body">
        <div class="col">
          <h4 class="modal-title">Terms & Conditions</h4>
          <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="col mt-4">
          <div class="checkbox" *ngIf="!environment.production">
            <label><input type="checkbox" name="termCheck" id="termCheck" name="termCheck" [(ngModel)]="f.termCheck"
                #termCheck="ngModel" required> I hereby agree to the <a
                href="https://pamstaging2.securenow.in/terms-conditions" target="_blank">terms &amp;
                conditions</a> of the purchase of this policy.</label>
          </div>
          <div class="checkbox" *ngIf="environment.production">
            <label><input type="checkbox" name="termCheck" id="termCheck" name="termCheck" [(ngModel)]="f.termCheck"
                #termCheck="ngModel" required> I hereby agree to the <a
                href="https://securenow.in/terms-conditions" target="_blank">terms &amp;
                conditions</a> of the purchase of this policy.</label>
          </div>
          <div class="checkbox">
            <label><input type="checkbox" name="termCheck" id="termCheck5" name="termCheck5" [(ngModel)]="f.termCheck5"
                #termCheck2="ngModel" required> I confirm my current annual income justifies the condition of the
              maximum sum assured according to policy.</label>
          </div>
          <div class="checkbox">
            <label><input type="checkbox" name="termCheck" id="termCheck2" name="termCheck2" [(ngModel)]="f.termCheck2"
                #termCheck2="ngModel"> I here by agree to receive service SMS and email alerts</label>
          </div>
          <div class="checkbox" *ngIf="!environment.production">
            <label><input type="checkbox" name="termCheck" id="termCheck3" name="termCheck3" [(ngModel)]="f.termCheck3"
                #termCheck3="ngModel"> I would also like to add Standing instruction on my credit card for
              (paying)automatic future renewal premiums. <a
                href="https://pamstaging.securenow.in/blog/terms-and-conditions" target="_blank">Terms &amp;
                Conditions.</a></label>
          </div>
          <div class="checkbox" *ngIf="environment.production">
            <label><input type="checkbox" name="termCheck" id="termCheck3" name="termCheck3" [(ngModel)]="f.termCheck3"
                #termCheck3="ngModel"> I would also like to add Standing instruction on my credit card for
              (paying)automatic future renewal premiums. <a href="https://securenow.in/blog/terms-and-conditions/"
                target="_blank">Terms &amp; Conditions.</a></label>
          </div>
          <div class="checkbox">
            <label style="line-height: 1.5;"><input type="checkbox" name="termCheck" id="termCheck4" name="termCheck4"
                [(ngModel)]="f.termCheck4" #termCheck4="ngModel" required> I hereby declare
              that no proposed member is involved in any hazardous activity or occupation requiring significant manual
              labour, operating heavy machinery, handling hazardous material, working at
              heights/underground/construction
              sites/oil rigging, near high voltage, high temperature, working in aircrafts or sea-going vessels, armed
              forces or participating in adventure sports/activities. </label>
          </div>
        </div>

        <div class="col text-center mt-4">
          <button class="btn btn-bordered-blue" aria-label="Close" (click)="modalRef.hide();royalSundramProceedToPay();"
            [disabled]="f.form.invalid">Pay</button>
        </div>
      </div>
    </form>
  </ng-template>
  <div id="spinner" [hidden]="!loading">
    <div class="spinnerfull">
      <i class="fa fa-spinner fa-spin fa-3x"></i>
    </div>
  </div>
</section>
<section class="personalAccidentProposalThankYou" *ngIf="thankyouSection">
  <div class="container">
    <div class="col">
      <h4 class="payment-title text-center mt-4">Payment Successful</h4>
      <div class="insurer-image text-center mt-4">
        <img src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/insurer/careLogo.png"
          class="img-responsive" width="50%" alt="Religare Insurance">
      </div>
    </div>
    <div class="col download-document">
      <div class="insurer-image text-center">
        <img
          src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/common-icons/file-4.svg"
          class="img-responsive" width="20%" alt="Download Document">
      </div>
      <h4 class="download-title text-center mt-3">Download Policy Document</h4>
    </div>
    <div class="col contact-us text-center">
      <p class="title">For Endorsement and Claim Contact at:</p>
      <p class="call"><img
          src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/common-icons/phone.svg"><span>1860-500-4488</span><span
          class="bar"></span><span>1800-102-4488</span></p>
      <p class="call"><span><img
            src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/common-icons/message.svg"></span>customerfirst@religarehealthinsurance.com
      </p>
    </div>
    <div class="col footer-strip text-center">
      <img src="https://pamstaging2.securenow.in/static/images/securenow_logo.svg"
        class="img-responsive" width="40%" alt="Religare Insurance">
      <p class="call mt-3"><span>+91 9696683999</span><span class="bar"></span><span>support@securenow.in</span></p>
    </div>
  </div>
</section>
<section class="personalAccidentTransactionFailure" *ngIf="transactionFailureSection">
  <div class="container">
    <div class="col text-center failure-error">

      <div class="insurer-image mt-4">
        <img src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/common-icons/ERROR.svg"
          class="img-responsive" width="20%" alt="Error">
      </div>
      <h4 class="payment-title mt-4">Oops... Payment Failed</h4>
      <p class="error-message">{{errorStatus}}</p>
      <p class="error-message">{{errorInternalMsg}}</p>
      <!-- <p>Transaction Id: 778W990</p> -->
    </div>
    <div class="col failure-reasons">
      <ul class="oval">
        <li>The Card CVV or Expiry Date might be wrong</li>
        <li>Your Bank networks might be down</li>
      </ul>
      <div class="text-center mt-4">
        <button class="btn btn-bordered-blue">Try Again</button>
      </div>
    </div>
    <div class="col footer-strip text-center">
      <img src="https://pamstaging2.securenow.in/static/images/securenow_logo.svg"
        class="img-responsive" width="40%" alt="Religare Insurance">
      <p class="call mt-3"><span>+91 9696683999</span><span class="bar"></span><span>support@securenow.in</span></p>
    </div>
  </div>
  <div id="spinner" [hidden]="!loading">
    <div class="spinnerfull">
      <i class="fa fa-spinner fa-spin fa-3x"></i>
    </div>
  </div>
</section>


<!---payment gateway redirection-->
<form id="PostForm" #royalSundarmForm name="PostForm" autocomplete="off" action="{{paymentGateData.paymentGatewayURL}}"
  method="post" style="visibility: hidden">
  <input type="hidden" name="reqType" id="reqType" value="JSON">
  <input type="hidden" name="process" value="paymentOption">
  <input type="hidden" name="apikey" id="apikey" value="{{paymentGateData.apiKey}}">
  <input type="hidden" name="agentId" id="agentId" value="{{paymentGateData.agentId}}">
  <input type="hidden" name="premium" value="{{paymentGateData.finalPremium}}">
  <input type="hidden" name="quoteId" id="quoteId" value="{{paymentGateData.QuoteId}}">
  <input type="hidden" name="version_no" id="version_no" value="12345">
  <input type="hidden" name="strFirstName" id="strFirstName" value="{{paymentGateData.userName}}">
  <input type="hidden" name="strEmail" id="strEmail" value="{{paymentGateData.emailForRS}}">
  <input type="hidden" name="isQuickRenew" id="isQuickRenew" value="">
  <input type="hidden" name="crossSellProduct" id="crossSellProduct" value="">
  <input type="hidden" name="crossSellQuoteid" id="crossSellQuoteid" value="">
  <input type="hidden" name="returnUrl" id="returnUrl" value="{{paymentGateData.returnUrl}}">
  <input type="hidden" value="privatePassengerCar" name="vehicleSubLine" id="vehicleSubLine">
  <input type="hidden" value="" name="elc_value" id="elc_value">
  <input type="hidden" value="" name="nonelc_value" id="nonelc_value">
  <input type="hidden" value="billDesk" name="paymentType" />
  <input type="submit" class="btn-view-summary" value="Submit" title="Submit">
</form>
